/*global translate*/
import { connect } from 'react-redux'
import * as Jsx from './index.jsx'
import React, { Fragment } from 'react'
import '@lottiefiles/lottie-player';
const { REACTIONS } = global.rootRequire('global/obj/global')

const stickerDataObj = global.rootRequire('classes/stickerData.json');
const RxComponent = global.rootRequire('components/shares/rxComponent').default
const { timeConverter, timeToDate, secondToTime, rxaget, formatBytes, subString, changeTheme, changeTheme_ThemeColor, changeThemeColor, rxconfig, isElectron, sortArrObj, timesUnixToDate, convertSecondUnix, changeColorSVG, getExtension } = global.rootRequire('classes/ulti')
const { changeUserStatus, netaGroupsRemove, netaBlobsUpdate, netaMessUpdate, netaMessPin, chooseGroupAction, netaUserUpdate, netaGroupsUpdate, netaGroupsUpdateLastMess, changeStatusTabmore, netaLinkAdd, netaMediaOneAdd, userClickUpdate, clickGroupCall, netaGroupCallRemove, netaMediaOneDel, rxnavToggle, changeGroupFunc, changePollsFunc } = global.rootRequire('redux')
const { checkIsOwner, parseMessageDesc, checkNameUser, checkNameGroup, getDeleteMessStr, checkBlock, clearIndexedDB, getAttachments } = global.rootRequire('classes/chat')
const rxio = global.rootRequire('classes/socket').default
const { rxgetLocal, rxsetLocal } = global.rootRequire('classes/request')
const themeData = global.rootRequire('classes/themeData.json')
const themeColorData = global.rootRequire('classes/themeColorData.json')
const theme_themeColorData = global.rootRequire('classes/theme_themeColorData.json')

const workerGroup = global.rootRequire('classes/globalGroups')
const workerStatus = global.rootRequire('classes/globalStatus')
const workerUnread = global.rootRequire('classes/globalUnread')
const worker = global.rootRequire('classes/globalUser')
let zget = global.rxu.get

const chatDB = global.rootRequire('classes/indexedDB').default

const maxUser = 5000

window.loadingFileCancel = (message_id) => {
  let ele = document.getElementById(message_id);
  if (ele) {
    ele.closest("div.zmessage_row").style.display = "none";
  }
  window.vmChat.setState({ cancelLoadingFile: true })
}

class MessageComponent_ extends RxComponent {
  constructor(props, context) {
    super(props, context, Jsx)
    this.state = {
      stickerFolderName: [],
      arrTabsDisplay: [],
      messages: {},
      pinedMess: {},
      group_id: rxaget(this.props, 'rxgroup.groupid', ''),
      group: rxaget(this.props, 'rxgroup.group', {}),
      groupfw: '',
      scroll_mess: true,
      scrollChatBoxStatus: false,
      tabmore: rxaget(this.props, 'tabmore.data', false),
      id_userclick: '',
      groupid_forward_old: 'null',
      tabmoreNextprop: false,
      seenMess: false,
      lastSeenMessId: '',
      lastSeenMessObj: {},
      userInfo: {},
      screenUserInfo: false,
      avatarClick_user: '',
      avatarClick_omess: '',
      pathImg: './images/sticker',
      currentAvatarUser: '',
      currentNameUser: '',
      displayScrollDownBtn: false,
      isForwardAudio: false,
      tagnameClick_status: false,
      arrData: [],
      tabActive: 'images',
      userClick_group: {},
      displaymodalpin: '',
      displayDragAndDrop: false,
      cancelLoadingFile: false,
      isBlocked: 0,
      selectedMessId: 0,
      currentMessageIdClicked: null,
      changeListMess: false,
      infoUserScreen: false,
      infoUserId: 0,
      flagPollListOption: false,
      pollInfo: {},
    }
    this.dropRef_Mess = React.createRef()
    this.refScroll_chat = {}

    let tmp_stickerFolderName = rxgetLocal('netaStickerFolder')
    if (tmp_stickerFolderName) {
      tmp_stickerFolderName = global.rxu.json(rxgetLocal('tmp_stickerFolderName'), {})
      this.state.stickerFolderName = tmp_stickerFolderName
    }

    let dataSticker = global.rxu.json(rxgetLocal('rxsticker'), {})
    if (dataSticker.pathimg) {
      this.state.pathImg = dataSticker.pathimg
    }


    this.groupid_forward = 'null'
    this.token = rxaget(this.props, 'netaauth.user.token', '')
    this.user = rxaget(this.props, 'netaauth.user', '')
    this.userid = rxaget(this.props, 'netaauth.user.id', '')
    this.users = {}//rxaget(this.props, 'user.users', {})
    this.groups = rxaget(this.props, 'netaGroups.groups', {})

    this.pg_mess = 0
    this.pg_down_mess = 0
    this.firstMessUpId = ''
    this.lastMessDownId = ''
    this.disableScrollDown = true

    this.countNoti = {}
    this.loadRenderer = 0
    this.indexImageForward = -1
    this.strImgForward = ''
    this.timer = {}

    this.state.mess_reply = {}
    this.state.mess_selected = {}
    this.state.mess_id = ''
    this.state.pin_mess_id = ''
    this.state.type_option = 0
    this.state.audio = {}

    this.arrFilesTmp = []
    this.checkImage = {}
    this.currentLastMess = {}
    this.checkLink = {}
    this.blockDownload = false
    this.flagCheckUnread = false
    this.flagSearchMess = false
    this.resendPollAction = { flag: false, mess: {} }

    this.keyClickFunction = this.keyClickFunction.bind(this);
    this.changeMessage = this.changeMessage.bind(this)
    this.scrollChatBox = this.scrollChatBox.bind(this)
    this.playAudio = this.playAudio.bind(this)
    this.downloadFile = this.downloadFile.bind(this)
    this.openExternalLink = this.openExternalLink.bind(this)
    this.showGallery = this.showGallery.bind(this)
    this.getGallery = this.getGallery.bind(this)
    this.handleMessage = this.handleMessage.bind(this)
    this.reloadStateWhenRepMess = this.reloadStateWhenRepMess.bind(this)
    this.resetSelectedMess = this.resetSelectedMess.bind(this)
    this.unPin = this.unPin.bind(this)
    this.loadHandleSocket = this.loadHandleSocket.bind(this)
    this.clickInfoUser = this.clickInfoUser.bind(this)
    this.onClickNameUser = this.onClickNameUser.bind(this)
    this.handleClickOutside = this.handleClickOutside.bind(this)
    this.onClickGroupCall = this.onClickGroupCall.bind(this)
    this.cancleUpload = this.cancleUpload.bind(this)
    this.parseMessage = this.parseMessage.bind(this)
    this.timerUnread = this.timerUnread.bind(this)

    window.vmChat = this //register vm

    let callGroupId = this.props.callGroupId
    if (callGroupId) {
      let group = this.groups[callGroupId]
      this.state.group = group
      this.props.chooseGroupAction(group)
      this.scrollDownChatList()
    }
    let isBlocked = checkBlock(this.state.group, this.userid)
    this.state.isBlocked = isBlocked

    this.objMessOld = {}
    this.groupSeenLast = {}

    let occupantsUins = rxaget(this.state, 'group.occupants_uins', [])
    let removedUins = rxaget(this.state, 'group.removed_uins', [])
    let userGroupUins = [...occupantsUins, ...removedUins]
    let arrUins = userGroupUins.map(o => Number(o)).sort()
    chatDB.users.bulkGet(arrUins).then(arrUserInDB => {
      for (let user of arrUserInDB) {
        if (user && user.id) {
          this.users[user.id] = user
        }
      }
    }).catch(e => { })
    // this.getGroup(this.state.group.group_id)

    this.scrollBlock = false
    this.scrollDownBlock = false
    this.intervalUnread = null
  }

  componentDidMount() {
    let div = this.dropRef_Mess.current
    div.addEventListener('dragenter', this.handleDragIn)
    if (rxio.socket) {
      rxio.socket.on('user_status', (data) => {
        if (data && data.user_status && data.user_status.constructor === Array && data.user_status.length > 0) {
          for (let oUser of data.user_status) {
            let flagStatus = (oUser.online_status === 2) ? false : true
            workerStatus.updateStatus(oUser.uin, oUser.last_seen_at, flagStatus)
          }
          this.props.changeUserStatus(data.user_status)
        }
      })

    }


    let chatRoot = document.getElementById('chat-root');
    if (chatRoot) {
      chatRoot.addEventListener('reloadPage', (e) => {
        if (e.detail && e.detail.reload) {
          console.log('Load Message')
          // this.fetchGroups(0)
          let group = this.state.group
          if (group) {
            this.chooseGroup(group)
          }
        }
      })
    }

    let chatInput = document.getElementById('chat-value');
    if (chatInput) {
      chatInput.addEventListener('chatInput', (e) => {
        if (e.detail && e.detail.type === 'choosePoll') {
          this.choosePoll(e.detail.data)
        } else if (e.detail && e.detail.type === 'pinPoll') {
          this.pinPoll(e.detail.data.message)
        } else if (e.detail && e.detail.type === 'repinPoll') {
          this.repinPoll(e.detail.data.message)
        } else {
          if (e.detail && e.detail.data && e.detail.data.message_id && this.state.group && e.detail.data.group_id === this.state.group.group_id) {
            let lastMessCurrent = e.detail.data
            this.currentLastMess = {
              group_id: e.detail.data.group_id,
              message_id: e.detail.data.message_id
            }
          }

          if (!this.disableScrollDown) {
            // this.scrollDownChatList()
          } else {
            if (this.arrFilesTmp && this.arrFilesTmp.length > 0 && e.detail && e.detail.data && !e.detail.data.name && e.detail.data.attachments && this.userid.toString() === e.detail.data.sender_uin) {
              if (e.detail.data.type === 12) {
                try {
                  let attachmentObjTmp = JSON.parse(e.detail.data.attachments)
                  if (attachmentObjTmp && attachmentObjTmp.file && attachmentObjTmp.file.file_name) {
                    let flagChange = false
                    for (let iMess in this.arrFilesTmp) {
                      if (this.arrFilesTmp[iMess]['name'] === attachmentObjTmp.file.file_name) {
                        this.arrFilesTmp.splice(iMess, 1)
                        flagChange = true
                        break
                      }
                    }
                    if (flagChange) {
                      this.setState({ messages: this.state.messages })
                    }
                  }
                } catch (e) {
                  console.log(e)
                }
              }
            }

            if (e.detail && e.detail.data && e.detail.data.name && e.detail.data.type === 12) {
              this.arrFilesTmp.push(e.detail.data)
              this.setState({ messages: this.state.messages })
            } else {
              this.handleMessage(e.detail.data, e.detail.scroll)
            }
          }
        }
      })
    }

    try {
      let stickerFolderName = []
      let stickerDataTmp = global.rxu.json(rxgetLocal('rxsticker'), {})
      let stickerData = (stickerDataTmp.version) ? stickerDataTmp : stickerDataObj
      if (stickerData && stickerData.stickerData) {
        stickerData.stickerData.forEach(o => {
          if (o.type && o.type !== 'history' && o.type !== 'EmojiIcon') {
            stickerFolderName.push(o.type)
          }
        })
      }
      let group = rxaget(this.props, 'rxgroup.group', {})
    }
    catch (e) {
      console.log(e)
    }

    this.loadDidMount()

    if (window && window.ipcRenderer) {

      // window.ipcRenderer.on('click_open_app', (event, args) => {
      //   let group = rxaget(this.props, 'rxgroup.group', {})
      //   if (group && group.group_id) {
      //     chatDB.noti.delete(Number(group.group_id)).catch((e) => {})
      //     chatDB.noti.count().then((cntBadge) => {
      //       try {
      //         window.ipcRenderer.send('update_badge', cntBadge)
      //       } catch(e) {}
      //     }).catch((e)=>{})
      //   }
      // })

      window.ipcRenderer.on('reload_page', (event, args) => {
        if (rxaget(this.state.group, 'group_id', '') !== '') {
          this.countNoti = {}
          this.arrFilesTmp = []
          // this.chooseGroup(this.state.group)

          if (this.loadRenderer < 2) {
            rxio.getWaitMessage((data) => {
              this.handleMessage(data, true)
            })
            rxio.getWaitMessDel((data) => {
              this.handleMessage(data, false)
            })
          }

          this.loadRenderer += 1

        }
      })

      window.ipcRenderer.on('clear_cache', () => {
        clearIndexedDB()
      })

      window.ipcRenderer.on('open_deeplink', (event, deepLinkUrl) => {
        if (deepLinkUrl) {
          try {
            let arrRegexStr = deepLinkUrl.match(/\?token=([a-z0-9\-]+)\&?/i)
            if (arrRegexStr && arrRegexStr.length === 2 && arrRegexStr[1]) {
              let tokenStr = arrRegexStr[1]
              rxio.joinLink(tokenStr, (data) => {
                if (data && data.result === 1) {
                  alert(translate('Join Group Failed'))
                } else if (data && data.group) {
                  try {
                    let group_id = data.group.group_id
                    setTimeout(() => {
                      this.fetchGroupDetail(group_id)
                      const msgUpGroup = {
                        group_id: Number(group_id),
                        name: '',
                        avatar_url: '',
                        push_all: [this.userid.toString()]
                      }
                      rxio.updateGroup(msgUpGroup, (data) => { })
                    }, 200)

                  } catch (e) { console.log("e", e) }
                }
              })
            } else {
              alert(translate('Join Group Failed'))
            }
          } catch (e) {
            alert(translate('Join Group Failed'))
          }
        } else {
          alert(translate('Join Group Failed'))
        }
      })

      window.ipcRenderer.on('new_sticker', (event, args) => {
        if (args) {
          try {
            let objSticker = JSON.parse(args)
            if (objSticker.version) {
              // this.updateSticker(objSticker)
              this.setState({ pathImg: objSticker.pathimg })
            }
          } catch (e) {
          }
        }
      })
    }
    const color = global.rxu.json(rxgetLocal('netaThemeColor'), '')
    const themeBackGround = global.rxu.json(rxgetLocal('netaThemeBackGround'), '')

    if (themeBackGround === 'darkTheme') {
      changeTheme(themeData.nightTheme)
      changeTheme_ThemeColor(theme_themeColorData.nightTheme)
    } else {
      changeTheme(themeData.defaultTheme)
      if (color === 'blueColor') {
        changeTheme_ThemeColor(theme_themeColorData.blueColor)
      } else {
        changeTheme_ThemeColor(theme_themeColorData.orangeColor)
      }
    }
    if (color === 'blueColor') {
      changeThemeColor(themeColorData.blueColor)
    } else {
      changeThemeColor(themeColorData.orangeColor)
    }

    this.intervalUnread = setInterval(this.timerUnread, 3000);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    let isBlocked = checkBlock(rxaget(nextProps, 'rxgroup.group', {}), this.userid)
    if (isBlocked !== this.state.isBlocked) {
      this.setState({ isBlocked })
    }

    if (rxaget(nextProps, 'rxgroup.groupid', '') &&
      rxaget(nextProps, 'rxgroup.group.group_id', '') &&
      rxaget(nextProps, 'rxgroup.groupid', '') !== this.state.group_id) {
      try {
        let group = rxaget(nextProps, 'rxgroup.group', {})
        if (typeof group !== 'undefined') {
          let groupId = rxaget(nextProps, 'rxgroup.groupid', '')
          let rxlastSeenMessId = ''
          if (group.seen_list[1]) {
            rxlastSeenMessId = group.seen_list[1].message_id
          } else {
            if (group.seen_list[0]) {
              rxlastSeenMessId = group.seen_list[0].message_id
            }
          }
        }
      }
      catch (e) {
        // console.log('error',e)
      }

      // if (this.state.group && this.state.group.group_id && this.objMessOld[this.state.group.group_id]) {
      //   if (this.state.group && this.state.group.occupants_uins && this.state.group.occupants_uins.length < maxUser) {
      //     this.checkReadedOne(this.state.group.group_id, this.objMessOld[this.state.group.group_id])  
      //   }
      // }


      let occupantsUins = rxaget(nextProps, 'rxgroup.group.occupants_uins', [])
      let removedUins = rxaget(nextProps, 'rxgroup.group.removed_uins', [])
      let userGroupUins = [...occupantsUins, ...removedUins]
      let arrUins = userGroupUins.map(o => Number(o)).sort()
      chatDB.users.bulkGet(arrUins).then(arrUserInDB => {
        for (let user of arrUserInDB) {
          if (user && user.id) {
            this.users[user.id] = user
          }
        }
        this.currentLastMess = {}
        this.setState({ group: nextProps.rxgroup.group })
      }).catch(e => {
        this.setState({ group: nextProps.rxgroup.group })
      })
      this.arrFilesTmp = []

      this.chooseGroup(rxaget(nextProps, 'rxgroup.group', {}))
    } else {

      let occupantsUins = rxaget(nextProps, 'rxgroup.group.occupants_uins', [])
      let removedUins = rxaget(nextProps, 'rxgroup.group.removed_uins', [])
      let userGroupUins = [...occupantsUins, ...removedUins]
      let groupObj = rxaget(nextProps, 'rxgroup.group', {})
      let arrUins = userGroupUins.map(o => Number(o)).sort()
      chatDB.users.bulkGet(arrUins).then(arrUserInDB => {
        for (let user of arrUserInDB) {
          if (user && user.id) {
            this.users[user.id] = user
          }
        }
        this.setState({ group: groupObj })
      }).catch(e => {
        this.setState({ group: groupObj })
      })
      this.arrFilesTmp = []
    }
    // if(nextProps.rxgroup && nextProps.rxgroup.group){
    //   let groupNextTmp = {...nextProps.rxgroup.group}
    //   this.checkResetCounNoti(groupNextTmp) 
    // }

    // }
    // let mess_selected = this.state.mess_selected
    // if (typeof mess_selected.groupfw === 'undefined') {
    //   if (mess_selected.group_id && (mess_selected.group_id !== rxaget(nextProps, 'rxgroup.group.group_id', ''))) {
    //     this.resetSelectedMess()
    //   }
    // } else {
    //   if (mess_selected.groupfw !== rxaget(nextProps, 'rxgroup.group.group_id', '')) {
    //     this.resetSelectedMess()
    //   }
    // }

    // if (rxaget(nextProps, 'loadmess.data', false) !== rxaget(this.props, 'loadmess.data', false)) {
    //   this.loadDidMount()
    // }
    // if (JSON.stringify(nextProps.tabmore.data) !== JSON.stringify(this.state.tabmoreNextprop) ||
    //   JSON.stringify(lastSeenMessObj) !== JSON.stringify(this.state.lastSeenMessObj)) {
    //   this.setState({ tabmoreNextprop: nextProps.tabmore.data, lastSeenMessObj: lastSeenMessObj })
    // }
    // if (nextProps.netaGroups && 
    //   // JSON.stringify(nextProps.netaGroups) !== JSON.stringify(this.netaGroups)
    //   nextProps.netaGroups.status !== rxaget(this.props, 'netaGroups.status', {})) {
    //   this.groups = rxaget(nextProps, 'netaGroups.groups', {})
    //   this.netaGroups = nextProps.netaGroups
    //   let groupsTmp = JSON.parse(JSON.stringify(rxaget(nextProps, 'netaGroups.groups', {})))
    //   let arrGroupsTmp = []
    //   Object.keys(groupsTmp).forEach(keygroup => {
    //     if (groupsTmp[keygroup].last_message) {
    //       try {
    //         groupsTmp[keygroup].timestamp = (groupsTmp[keygroup].last_message.created_at
    //           && Number(groupsTmp[keygroup].last_message.created_at)) || new Date().getTime() * 1000
    //         arrGroupsTmp.push(groupsTmp[keygroup])
    //       } catch (error) { }
    //     }
    //   })
    //   let arrGroups = arrGroupsTmp.sort((a, b) => (a.timestamp > b.timestamp) ? -1 : ((b.timestamp > a.timestamp) ? 1 : 0))
    //   arrGroups.forEach(ogroup => {
    //     ogroup.group_fullname = checkNameGroup(ogroup, this.users, this.userid)
    //     if (ogroup && (ogroup.type === 3 || ogroup.type === 5) && !ogroup.avatar_url && rxaget(ogroup, 'occupants_uins', []).length === 2) {
    //       const arrUins = rxaget(ogroup, 'occupants_uins', [])
    //       ogroup['partner_id'] = (arrUins[0].toString() === this.userid.toString()) ? arrUins[1] : arrUins[0]
    //     }
    //   })
    // }
  }

  checkReadedOne(group_id, mess_id) {
    const msg = {
      group_id: group_id,
      message_id: mess_id,
      message: '',
      status: 3
    }

    if (rxio.connected) {
      rxio.socket.emit('update_message', msg, (data) => { })
    }
  }

  checkResetCounNoti(group) {
    let countUnread = (rxaget(group, 'count_unread', 0) > 0) ? rxaget(group, 'count_unread', 0) : rxaget(group, 'unread_cnt', 0)

    if (this.countNoti[group.group_id] && countUnread === 0) {
      let size = Object.keys(this.countNoti[group.group_id]).length;
      if (size > 0) {
        this.countNoti[group.group_id] = {}
      }
    }
  }

  getGroupByUserId(partner_id) {
    let group = {}
    let groupsTmp = this.users[partner_id]
    if (groupsTmp) {
      let group_id = groupsTmp.group_id
      if (group_id) {
        group = this.groups[group_id]
      }
    }

    return group
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.keyClickFunction, false);
    document.removeEventListener('mousedown', this.handleClickOutside);
    window.playAudio = null
    window.onClickGroupCall = null
    window.downloadFile = null
    window.showGallery = null
    window.getGallery = null
    window.openExternalLink = null
    window.cancleUpload = null
    window.showInfoUser = null

    let div = this.dropRef_Mess.current
    div.removeEventListener('dragenter', this.handleDragIn)

    clearInterval(this.intervalUnread)
  }

  timerUnread() {
    if (this.currentLastMess && this.currentLastMess.message_id && this.currentLastMess.group_id) {
      let group_id = this.currentLastMess.group_id
      let lastMessId = this.currentLastMess.message_id
      this.checkReadedOne(group_id, lastMessId)

      chatDB.groups.get({ group_id: group_id.toString() }).then(groupInDB => {
        if (groupInDB) {
          chatDB.groups.update(group_id.toString(), { my_seen_mess: lastMessId })
        }
      })

      this.currentLastMess = {}
    }

    if (this.flagCheckUnread) {
      this.props.changeGroupFunc()
      this.flagCheckUnread = false
    }
  }

  handleDragIn = (e) => {
    e.preventDefault()
    e.stopPropagation()
    this.setState({ displayDragAndDrop: true })
  }

  handleDragOut(e) {
    this.setState({ displayDragAndDrop: false })
  }

  updateLastSeen(messid_org, messid_new, group_id) {
    try {
      if ((messid_org && (Number(messid_org) < Number(messid_new))) || !messid_org) {
        this.groupSeenLast[group_id] = messid_new

        chatDB.groups.update(group_id.toString(), { another_seen_mess: messid_new }).then((updated) => {
          let seenMess = this.state.seenMess
          this.flagCheckUnread = true
          this.setState({ seenMess: !seenMess })
        }).catch(e => {
          console.log(e)
        })
      }
    } catch (e) { }
  }

  loadHandleSocket() {
    rxio.getWaitConnect((data) => {
      if (data) {
        if (rxaget(this.props, 'rxgroup.group.group_id', '') !== '') {
          this.chooseGroup(this.state.group)
        }
        rxio.getWaitMessage((data) => {
          if (data.type === 17) {
            this.checkAndUpdatePolls(data)
          }
          chatDB.mess.put(data, data.message_id)

          workerGroup.addGroup(data.group_id, data)


          chatDB.groups.get({ group_id: data.group_id }).then(groupInDB => {
            if (groupInDB) {
              let checkShow = this.checkGroupsAdminLeave(groupInDB, data)
              if (checkShow) {
                let last_sort = '1' + groupInDB.flagDraf + groupInDB.flagPin + data.created_at
                let updateGroup = {
                  last_message: data,
                  last_message_id: data.message_id,
                  last_sort: last_sort
                }

                if (this.state.group && this.state.group.group_id !== data.group_id) {
                  let oldUnread = rxaget(groupInDB, 'count_unread', 0)
                  if (data.sender_uin !== this.userid.toString()) {
                    updateGroup['count_unread'] = Number(oldUnread) + 1
                    let typeFolder = (groupInDB.folders && groupInDB.folders.constructor === Array && groupInDB.folders.length > 0) ? groupInDB.folders[0] : '2'
                    workerUnread.initUnread(groupInDB.group_id, typeFolder)
                  }
                }

                if (data.attachments.indexOf('added_uins') !== -1) {
                  this.fetchGroupDetail(data.group_id.toString(), true)
                }

                chatDB.groups.update(data.group_id.toString(), updateGroup).then((updated) => {
                  this.props.changeGroupFunc()
                }).catch(e => { })
              }
            } else {
              let elem = document.getElementById('chat-root')
              if (elem) {
                this.fetchGroupUpdateDetail(data.group_id.toString(), data)
                setTimeout(() => {
                  try {
                    let checkReload = global.rxu.json(rxgetLocal('checkReload'), {}) || {}

                    if (checkReload && !checkReload[data.group_id]) {
                      checkReload[data.group_id] = 1
                    }

                    if (checkReload[data.group_id] < 3) {
                      elem.dispatchEvent(new CustomEvent('reloadPage', { detail: { reload: true } }))
                    }

                    checkReload[data.group_id] += 1

                    rxsetLocal('checkReload', JSON.stringify(checkReload))
                  } catch (e) {
                    elem.dispatchEvent(new CustomEvent('reloadPage', { detail: { reload: true } }))
                  }
                }, 2000)
              }
            }

          })
          // if (groupInDB) {
          //   ogroup.flagDetail = false
          // } else {
          //   ogroup.flagDetail = ogroup.flagDetail || false


          // }


          if (data && data.sender_uin && Number(data.sender_uin) !== Number(this.userid) && data.message_id) {
            this.objMessOld[data.group_id] = data.message_id
          }

          this.handleMessage(data, true)
          try {
          } catch (e) { }
        })


        rxio.getWaitLiveLocation((data) => {
          chatDB.mess.put(data, data.message_id)
          this.handleMessage(data, true)
          try {
          } catch (e) { }

        })

        rxio.getUpdateMessage((data) => {
          try {
            if (data && data.seen_uins.length > 0 && data.seen_uins.indexOf(this.userid.toString()) !== -1) {
              workerUnread.initUnread(data.group_id.toString(), '-1')
              chatDB.groups.update(data.group_id.toString(), { count_unread: 0, my_seen_mess: data.message_id }).then(o => {
                this.props.changeGroupFunc()
              }).catch(e => { })
            } else if (data && data.seen_uins.length > 0 && data.seen_uins.indexOf(this.userid.toString()) === -1) {

              if (this.groupSeenLast[data.group_id.toString()]) {
                this.updateLastSeen(this.groupSeenLast[data.group_id.toString()], data.message_id, data.group_id.toString())
              } else {
                chatDB.groups.get({ group_id: data.group_id }).then(groupInDB => {
                  if (groupInDB) {
                    this.updateLastSeen(groupInDB.another_seen_mess, data.message_id, data.group_id.toString())
                  }
                })
              }
            }
          }
          catch (e) {
          }

        })
        rxio.getUpdateGroup(async (data) => {
          try {
            let groupObjSelected = this.state.group
            let groupId = (data.group_id) ? data.group_id : (data.group && data.group.group_id) ? data.group.group_id : ''
            let groupObj = await chatDB.groups.get({ group_id: groupId })
            if (groupObj) {
              if (data.avatar_url || data.name || data.description) {
                let paramsUpdateGroup = {}
                let flagChange = false
                let groupName = data.name || groupObj.name

                if (groupName !== groupObj.name) {
                  flagChange = true
                  paramsUpdateGroup = {
                    name: groupName,
                    group_fullname: groupName
                  }
                }

                if (data.avatar_url) {
                  flagChange = true
                  paramsUpdateGroup['avatar_url'] = data.avatar_url || groupObj.avatar_url
                }

                if (data.description) {
                  flagChange = true
                  paramsUpdateGroup['description'] = data.description

                  if (groupObj.description !== data.description) {
                    groupObj.description = data.description
                  }
                }

                if (flagChange) {
                  chatDB.groups.update(rxaget(data, 'group_id', '').toString(), paramsUpdateGroup).then(o => {
                    this.props.changeGroupFunc()
                  }).catch(e => { })
                  if (groupObjSelected.group_id === data.group_id) {

                    groupObj.avatar_url = data.avatar_url || groupObj.avatar_url
                    groupObj.name = data.name || groupObj.name
                    groupObj.group_name = data.group_name || data.name || groupObj.group_name
                    groupObj.group_fullname = data.group_fullname || data.name || groupObj.group_fullname

                    this.props.chooseGroupAction(groupObj)
                  }
                }
              }

              if (data.owner_uin && Number(data.owner_uin) > 0) {
                groupObj.owner_uin = data.owner_uin
                this.props.netaGroupsUpdate(data.group_id, groupObj)

                chatDB.groups.update(rxaget(data, 'group_id', '').toString(), {
                  owner_uin: data.owner_uin.toString()
                }).then(o => {
                  this.props.changeGroupFunc()
                }).catch(e => { })

                if (groupObjSelected.group_id === data.group_id) {
                  this.props.chooseGroupAction(groupObj)
                }
              }
              if (data.deleted_admin_all.length > 0) {
                let groupObj = this.state.group
                let admin_uinsArr = groupObj.admin_uins
                for (let i = 0; i < data.deleted_admin_all.length; i++) {
                  let adminUinDel = data.deleted_admin_all[i].toString()
                  const indexDel = admin_uinsArr.indexOf(adminUinDel)
                  if (indexDel > -1) {
                    admin_uinsArr.splice(indexDel, 1)
                  }
                }

                groupObj.admin_uins = admin_uinsArr

                chatDB.groups.update(rxaget(data, 'group_id', '').toString(), {
                  admin_uins: admin_uinsArr
                }).then(o => {
                  this.props.changeGroupFunc()
                }).catch(e => { })

                if (groupObjSelected.group_id.toString() === data.group_id.toString()) {
                  groupObjSelected.admin_uins = admin_uinsArr
                  this.props.chooseGroupAction(groupObjSelected)
                }
              }
              if (data.added_admin_all.length > 0) {
                // let groupObj = this.state.group
                let admin_uinsArr = groupObj.admin_uins
                for (let i = 0; i < data.added_admin_all.length; i++) {
                  let admin_uin = data.added_admin_all[i]
                  admin_uinsArr.push(admin_uin.toString())
                }
                groupObj.admin_uins = admin_uinsArr

                chatDB.groups.update(rxaget(data, 'group_id', '').toString(), {
                  admin_uins: admin_uinsArr
                }).then(o => {
                  this.props.changeGroupFunc()
                }).catch(e => {
                })

                if (groupObjSelected.group_id.toString() === data.group_id.toString()) {
                  groupObjSelected.admin_uins = admin_uinsArr
                  this.props.chooseGroupAction(groupObjSelected)
                }
              }
              if (data.unblocked_all.length > 0 || data.blocked_all.length > 0) {
                groupObj.blocked_uins = data.blocked_all.length > 0 ? [...data.blocked_all] : []
                if (groupObjSelected.group_id.toString() === data.group_id.toString()) {
                  groupObjSelected.blocked_uins = [...data.blocked_all]
                  this.props.chooseGroupAction(groupObjSelected)
                }

                let isBlocked = checkBlock(groupObj, this.userid)
                this.setState({ isBlocked: isBlocked })

                this.props.netaGroupsUpdate(data.group_id, groupObj)
              }
              if (data.pull_all.length > 0) {
                // let groupObj = this.state.group
                let groupObjMemberIdArr = JSON.parse(JSON.stringify(groupObj.occupants_uins))
                let groupRemovedUins = rxaget(groupObj, 'removed_uins', [])
                let admin_uins = rxaget(groupObj, 'admin_uins', [])

                let memberLeaveGroup = Number(data.pull_all[0])
                let i = groupObjMemberIdArr.indexOf(memberLeaveGroup);
                if (i === -1) i = groupObjMemberIdArr.indexOf(memberLeaveGroup.toString());
                if (i !== -1) {
                  groupObjMemberIdArr.splice(i, 1)
                }
                groupObj.occupants_uins = groupObjMemberIdArr

                if (admin_uins.indexOf(memberLeaveGroup) !== -1) {
                  admin_uins = admin_uins.filter(uid => uid !== memberLeaveGroup)
                }

                if (groupRemovedUins.indexOf(data.pull_all[0].toString()) === -1) {
                  groupRemovedUins.push(data.pull_all[0].toString())
                }

                chatDB.groups.update(rxaget(data, 'group_id', '').toString(), {
                  admin_uins: admin_uins,
                  occupants_uins: groupObjMemberIdArr,
                  removed_uins: groupRemovedUins
                }).then(o => {
                  this.props.changeGroupFunc()
                }).catch(e => {
                })

                if (groupObjSelected.group_id.toString() === data.group_id.toString()) {
                  groupObjSelected.occupants_uins = groupObjMemberIdArr
                  groupObjSelected.removed_uins = groupRemovedUins
                  this.props.chooseGroupAction(groupObjSelected)
                }

                this.setState({ group: groupObjSelected })

                if (data.pull_all.indexOf(this.userid.toString()) >= 0) {
                  if (groupObjSelected.group_id.toString() === data.group_id.toString()) {
                    this.props.callBackBlockFooter()
                  }
                  workerUnread.initUnread(data.group_id.toString(), '-1')
                  chatDB.groups.delete(data.group_id.toString()).catch((e) => {
                    this.props.changeGroupFunc()
                    // console.log(e)
                  })
                  // this.props.netaGroupsRemove(groupObj.group_id)
                  // if (groupObjSelected.group_id.toString() === data.group_id.toString()) {
                  //   try {
                  //     let arrGroups = []
                  //     Object.keys(this.groups).forEach(keygroup => {
                  //       if (this.groups[keygroup].last_message) {
                  //         this.groups[keygroup].timestamp = (this.groups[keygroup].last_message.created_at
                  //           && Number(this.groups[keygroup].last_message.created_at)) || new Date().getTime() * 1000
                  //         arrGroups.push(this.groups[keygroup])

                  //       }
                  //     })
                  //     arrGroups = arrGroups.sort((a, b) => (a.timestamp > b.timestamp) ? -1 : ((b.timestamp > a.timestamp) ? 1 : 0))
                  //     const i = arrGroups.findIndex(o => o.group_id.toString() === data.group_id.toString())
                  //     let curIndex = i ? 0 : 1
                  //     this.props.chooseGroupAction(arrGroups[curIndex])
                  //   } catch (error) { console.log("error", error) }
                  // }
                }
              }

              if (data.push_all.length > 0) {
                if (groupObj) {
                  let groupObjMemberIdArr = JSON.parse(JSON.stringify(groupObj.occupants_uins))
                  let memberArrPush = data.push_all
                  for (let i = 0; i < memberArrPush.length; i++) {
                    groupObjMemberIdArr.push(String(memberArrPush[i]))
                  }
                  groupObj.occupants_uins = Array.from(new Set(groupObjMemberIdArr))
                  // this.props.netaGroupsUpdate(data.group_id, groupObj)
                  await chatDB.groups.update(data.group_id, { occupants_uins: groupObjMemberIdArr })
                  this.props.changeGroupFunc()

                  if (rxaget(this.props, 'rxgroup.groupid', '') === data.group_id) {
                    this.props.chooseGroupAction(groupObj)
                  }

                  let occupantsUins = rxaget(groupObj, 'occupants_uins', [])
                  let removedUins = rxaget(groupObj, 'removed_uins', [])
                  let userGroupUins = [...occupantsUins, ...removedUins]
                  let arrUins = userGroupUins.map(o => Number(o)).sort()
                  let arrUserInDB = await chatDB.users.bulkGet(arrUins)

                  let flagDetail = false
                  for (let user of arrUserInDB) {
                    if (user && user.id) {
                      this.users[user.id] = user
                    }

                    if (!user) {
                      flagDetail = true
                    }
                  }
                  if (flagDetail) {
                    this.fetchGroupDetail(groupObj.group_id, true)
                  }
                }
              }

              if (data.pinned_message && groupObjSelected.group_id === data.group_id) {
                try {
                  this.setState({ pinedMess: this.pushToObjMess(this.state.pinedMess, data.pinned_message, "pinned_at") }, () => {
                  })
                } catch (e) { }
              }
              else if (data.unpinned_message_all && groupObjSelected.group_id === data.group_id) {
                try {
                  this.setState({ pinedMess: {} })
                } catch (e) { }
              }
            } else {
              let group_id = data.group_id
              if (data && data.push_all && data.push_all.length > 0 && data.push_all.indexOf(this.userid.toString()) !== -1) {
                this.fetchGroupDetail(group_id)
              }


            }
          } catch (e) { console.log("e", e) }
        })
        rxio.getWaitMessDel((data) => {
          if ([2, 3, 4, 12].indexOf(data && data.type) !== -1) {
            this.props.netaMediaOneDel(Number(data.group_id), data.attachments)
          }
          if (data.type === 17) {
            this.checkAndUpdatePolls(data)
          }
          chatDB.mess.put(data, data.message_id)
          this.handleMessage(data, false)
        })
        rxio.getPinGroup((data) => {
          this.handleMessage(data, false)
        })
        rxio.getUnpinGroup((data) => {
          this.handleMessage(data, false)
        })
        rxio.getEmojiEvent((data) => {
          this.handleMessage(data, false)
        })
        // setTimeout(() => {
        //   rxio.getUser_status((data) => {
        //     this.updateOnlineStatus(data)
        //   })
        // }, 300)
      } else {
        setTimeout(() => {
          this.loadHandleSocket()
        }, 300)
      }
    })
  }

  fetchGroupUpdateDetail(group_id, message) {
    if (group_id && this.token) {
      const api_group_detail = global.rxu.config.get_groups + '/' + group_id
      fetch(api_group_detail, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'TC-Token': this.token,
          Connection: 'Keep-Alive',
          'Accept-Encoding': 'gzip'
        },
        body: null
      }).then(res => res.json())
        .then((json) => {
          if (json && message && json.users && json.users.constructor === Array && json.users.length > 0) {
            try {
              let ogroup = rxaget(json, 'Group', {})
              let partnerUser = {}
              if (ogroup.occupants_uins.indexOf(this.userid) != -1) {
                ogroup.timestamp = (ogroup.last_message && ogroup.last_message.created_at) ? Number(ogroup.last_message.created_at) : (ogroup.updated_at) ? ogroup.updated_at : new Date().getTime() * 1000
                ogroup.flagDraf = (ogroup.flagDraf) ? ogroup.flagDraf : '0' // 0 or 1
                ogroup.flagPin = (ogroup && ogroup.pinned_uins && ogroup.pinned_uins.indexOf(this.userid.toString()) !== -1) ? '1' : '0'
                ogroup.last_sort = '1' + ogroup.flagDraf + ogroup.flagPin + ogroup.timestamp
                ogroup.last_message = message
                ogroup.count_unread = 1
                ogroup.unread_cnt = 1
                ogroup.received_list = []
                ogroup.seen_list = []
                ogroup.occupants_uins = ogroup.occupants_uins.map(String)
                ogroup.group_id = ogroup.group_id.toString()

                if (ogroup.owner_uin) { ogroup.owner_uin = ogroup.owner_uin.toString() }
                if (ogroup.creator_uin) { ogroup.creator_uin = ogroup.creator_uin.toString() }
                if (ogroup.admin_uins) { ogroup.admin_uins = ogroup.admin_uins.map(u => u.toString()) }
                if (ogroup.created_at) { ogroup.created_at = ogroup.created_at.toString() }
                if (ogroup.updated_at) { ogroup.updated_at = ogroup.updated_at.toString() }
                if (ogroup.last_message_id) { ogroup.last_message_id = message.message_id }
                if (ogroup.folders) {
                  ogroup.folders = ogroup.folders.map(u => u.toString())
                } else {
                  if (ogroup.type === 3) {
                    if (json.users && json.users.constructor === Array && json.users.length > 0) {
                      let partnerUserArr = json.users.filter(u => u.Id.toString() !== this.userid.toString())
                      if (partnerUserArr && partnerUserArr.constructor === Array && partnerUserArr.length > 0) {
                        partnerUser = partnerUserArr[0]
                        if (partnerUser && (partnerUser.phone.indexOf('ipa') !== -1 || partnerUser.phone.indexOf('pti') !== -1)) {
                          ogroup.folders = ['2']
                        } else {
                          ogroup.folders = ['3']
                        }
                      } else {
                        ogroup.folders = ['2']
                      }
                    }
                  } else {
                    ogroup.folders = ['2']
                  }
                }

                const arrUins = rxaget(ogroup, 'occupants_uins', [])

                ogroup['partner_id'] = 0
                ogroup['avatar_url'] = ogroup.avatar_url || ''

                let objUsers = []
                let arrNameTmp = []
                if (json.users && json.users.constructor === Array && json.users.length > 0) {
                  for (const user of json.users) {
                    if (!(rxaget(user, 'full_name', '') || rxaget(user, 'phone', ''))) {
                      user.full_name = translate('Stranger')
                    }
                    objUsers.push({ id: user.Id, uid: user.Id, ...user })

                    let uName = rxaget(user, 'full_name', '') || rxaget(user, 'phone', '')
                    if (uName) {
                      arrNameTmp.push(uName)
                    }

                    this.users[user.Id] = { id: user.Id, uid: user.Id, ...user }
                    worker.addUser(user.Id, { id: user.Id, uid: user.Id, ...user })
                  }
                }
                if (ogroup.type === 3 && (partnerUser.full_name || partnerUser.phone)) {
                  ogroup.name = (partnerUser.full_name) ? partnerUser.full_name : partnerUser.phone
                }

                if (json.removed_users && json.removed_users.constructor === Array && json.removed_users.length > 0) {
                  for (const user of json.removed_users) {
                    worker.addUser(user.Id, { id: user.Id, uid: user.Id, ...user })
                    if (rxaget(user, 'full_name', '') || rxaget(user, 'phone', '')) {
                      objUsers.push({ id: user.Id, uid: user.Id, ...user })
                    }
                  }
                }

                if (json.Group && json.Group.group_id.toString()) {
                  chatDB.users.bulkPut(objUsers)
                }

                ogroup['group_fullname'] = ogroup.name || arrNameTmp.slice(0, 3).join(', ')

                if (rxaget(this.state.group, 'group_id', '') === ogroup.group_id.toString()) {
                  this.setState({
                    changeListMess: true
                  })
                }

                workerUnread.initUnread(ogroup.group_id.toString(), '-1')
                chatDB.groups.add(ogroup, ogroup.group_id.toString()).then(g => {
                  if (partnerUser && partnerUser.phone) {
                    this.checkTypeUser(partnerUser.phone, ogroup.group_id)
                  }
                  this.props.changeGroupFunc()
                  setTimeout(() => {
                    this.handleNoti(message)
                  }, 500)
                }).catch(e => {
                  console.log(e)
                })
              }
            } catch (e) { }

          }
        }).catch(error => console.log(error))
    }
  }

  checkTypeUser(username, group_id) {
    if (username) {
      let api_profile = global.rxu.config.base_api_neta + '/api/users/profile/' + encodeURI(username)
      fetch(api_profile, {
        method: 'GET',
        headers: { Accept: 'application/json', 'TC-Token': this.token, Connection: 'Keep-Alive', 'Accept-Encoding': 'gzip' }
      }).then(res => res.json()).then((json) => {
        if (json.user_type && json.user_type === 1) {
          chatDB.groups.get({ group_id: group_id.toString() }).then(groupDB => {
            if (groupDB) {
              chatDB.groups.update(group_id.toString(), { folders: ['2'] }).then(o => {
                this.props.changeGroupFunc()
              }).catch(e => {
                console.log(e)
              })
            }
          })
        } else {
          rxio.socket.emit('update_group', { group_id: Number(group_id), folders: [3] }, (data) => {
            if (data && data.group && data.group.folders && data.group.folders.constructor === Array && data.group.folders.length > 0) {
              chatDB.groups.get({ group_id: group_id.toString() }).then(groupDB => {
                if (groupDB) {
                  chatDB.groups.update(group_id.toString(), { folders: ['3'] }).then(o => {
                    this.props.changeGroupFunc()
                  }).catch(e => {
                    console.log(e)
                  })
                }
              })
            }
          })
        }
      }).catch(error => {
        console.log("fetch Profile error")
      })
    }
  }

  loadDidMount() {
    document.addEventListener('keydown', this.keyClickFunction, false);
    document.addEventListener('mousedown', this.handleClickOutside);
    if (this.token && this.userid) {
      if (!rxio.connected && !rxio.init_connected) {
        rxio.login(this.token, this.userid, (data) => {
          if (rxaget(this.state.group, 'group_id', '') !== '') {
            this.chooseGroup(this.state.group)
          }
          rxio.getWaitMessage((data) => {
            this.handleMessage(data, true)
          })

          rxio.getWaitMessDel((data) => {
            this.handleMessage(data, false)
          })
        })
      } else {
        this.loadHandleSocket()
      }
    }

    if (window && window.ipcRenderer) {
      window.ipcRenderer.on('click_notification', (event, args) => {
        if (args && args.group_id) {
          chatDB.groups.get({ group_id: args.group_id }).then(groupInDB => {
            if (groupInDB) {
              this.chooseGroup(groupInDB)
              this.props.chooseGroupAction(groupInDB)
            }
          })
        }
      })

      window.ipcRenderer.on('close_stop_call', (event, args) => {
        if (args) {
          // window.location.reload(false)
          setTimeout(() => {
            rxio.reconnect()
            setTimeout(() => {
              console.log('Close Stop Call')
              if (args && args.call_id && args.group_id) {
                // rxio.stopCall(args, (data) => {})
              }
            }, 1000)
          }, 1000)

        }
      })

      window.ipcRenderer.on('set_link_review', (event, args) => {
        let objlink = rxaget(this.props, 'netaLink.data.' + args.uid, {})
        if (args && args.uid) {
          if (!objlink.uid) {
            this.props.netaLinkAdd(args.uid, args)
          }
        }
      })
    }
    window.playAudio = this.playAudio
    window.onClickGroupCall = this.onClickGroupCall
    window.downloadFile = this.downloadFile
    window.showGallery = this.showGallery
    window.getGallery = this.getGallery
    window.openExternalLink = this.openExternalLink
    window.cancleUpload = this.cancleUpload
    window.showInfoUser = this.clickInfoUser
  }

  closeScreenUserInfo() {
    this.setState({ screenUserInfo: false })
  }

  fetchImage(src, callback) {
    const timenow = Math.floor(Date.now() / 1000)
    try {
      let timeCreateImg = (typeof this.checkImage[src] !== 'undefined') ? rxaget(this.checkImage[src], 'created_at', 0) : 0
      if (!this.checkImage[src] || ((timenow - timeCreateImg) > 43200 && timeCreateImg > 0)) {
        fetch(src, { headers: { 'TC-Token': this.token }, redirect: 'follow' })
          .then(res => {
            if (res && res.redirected && res.url && src) {
              try {
                callback(res.url)
                this.props.netaBlobsUpdate(src, res.url)
              } catch (e) {
                callback('')
              }
            } else {
              callback('')
            }
          })
      } else {
        callback(rxaget(this.checkImage[src], 'link', ''))
      }
    } catch (e) {
      callback('')
    }
  }

  avatarClick(omess) {
    let usersinfo = zget(global.rxu.json(rxgetLocal('rxusers'), {}), 'users') || {}
    let userAvataClick = zget(usersinfo, [omess.sender_uin], {})
    this.setState({
      screenUserInfo: true,
      avatarClick_user: userAvataClick,
      avatarClick_omess: omess,
    })
  }

  convertOmessUser(omess) {
    let usersinfo = zget(global.rxu.json(rxgetLocal('rxusers'), {}), 'users') || {}
    let user = zget(usersinfo, [omess.sender_uin], {})
    return user
  }

  keyClickFunction(event) {
    if (event.keyCode === 27) {
      this.closeGallery()
    }
  }

  onClickGroupCall(data) {
    if (data.group_id && data.message_id) {
      this.props.clickGroupCall('groupcall', {
        group_id: rxaget(data, 'group_id', ''),
        message_id: rxaget(data, 'message_id', ''),
        type: rxaget(data, 'type', 0),
        occupants_uins: rxaget(data, 'group.occupants_uins', [])
      })
    }
  }

  playAudio(audio_id) {
    let audio = this.state.audio
    audio[audio_id] = (!audio[audio_id]) ? true : false
    this.setState({ audio: audio }, () => {
      const iconAudioDiv = document.getElementById(audio_id)
      if (iconAudioDiv) {
        let idDivAudio = audio_id.replace('icon-', '')
        let audioDiv = document.getElementById(idDivAudio)
        if (audio[audio_id]) {
          iconAudioDiv.src = './images/default/static/icon-media-pause.svg'
          if (audioDiv) {
            audioDiv.play()
            audioDiv.ontimeupdate = () => {
              const processAudioDiv = document.getElementById('process-' + idDivAudio)
              if (processAudioDiv) {
                processAudioDiv.style.width = ((audioDiv.currentTime / audioDiv.duration) * 100) + '%'
              }
              if (audioDiv.currentTime === audioDiv.duration) {
                audioDiv.load()
                iconAudioDiv.src = './images/default/static/icon-media-play.svg'
                processAudioDiv.style.width = '0%'
              }
            }
          }
        } else {
          iconAudioDiv.src = './images/default/static/icon-media-play.svg'
          if (audioDiv) {
            audioDiv.pause()
          }
        }
      }
    })
  }

  showGallery(strimages, index) {
    console.log('showGallery')
    // let flagStartCall = this.props.flagStartCall
    // if (!flagStartCall) {
    let a = this.state.displaymodalpin
    let b = this.state.checkgallery
    let c = this.state.galleryImages
    let d = this.state.galleryPosition

    this.setState({ displaymodalpin: false, checkgallery: true, galleryImages: strimages, galleryPosition: Number(index) })
    // }
  }

  getGallery(strimages, index) {
    this.indexImageForward = index
    this.strImgForward = strimages
  }

  closeGallery() {
    this.setState({ checkgallery: false, galleryImages: '' })
  }

  downloadFile(file_id, file_name) {
    const src = global.rxu.config.get_static + '/' + file_id
    try {
      if (!this.blockDownload) {
        this.blockDownload = true

        fetch(src)
          .then(resp => resp.blob())
          .then(blob => {
            const url = window.URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.style.display = 'none'
            a.href = url
            a.download = file_name
            document.body.appendChild(a)
            a.click()
            window.URL.revokeObjectURL(url)
            this.blockDownload = false
          })
          .catch(() => console.log('Error'))
      } else {
        alert(translate('Downloading your file please wait ...'))
      }

    } catch (e) { }
  }

  openExternalLink(url) {
    if (window && window.ipcRenderer && url) {
      window.ipcRenderer.send('open-external-link', { link: url })
    } else if (window && url) {
      window.open(url, '_blank')
    }
  }

  cancleUpload(messid, url) {
    try {
      if (url.indexOf('blob') !== -1) {
        this.removeMess(messid, true)
      }
    } catch (e) {
      console.log(e)
    }
  }

  scrollChatBox(e) {
    const chatListDiv = document.getElementById('zchat_list')
    let displayScrollDownBtn = false

    if (chatListDiv) {
      const scrollHeight = chatListDiv.scrollHeight
      const scrollTop = chatListDiv.scrollTop
      const clientHeight = chatListDiv.clientHeight

      setTimeout(() => {
        if (!this.scrollBlock) {
          let screen = window.screen
          if (scrollHeight - scrollTop > screen.height/*511 + 150*/) {
            displayScrollDownBtn = true
          }

          if (scrollHeight - scrollTop < clientHeight + 1) {
            if (this.lastMessDownId && !this.disableScrollDown) {
              this.pg_down_mess += 1
              this.scrollDownBlock = true
              this.loadMessages(scrollHeight, 'down')
            }
          }

          if (scrollHeight - scrollTop === scrollHeight) {
            this.pg_mess += 1

            this.scrollBlock = true
            this.loadMessages(scrollHeight, 'up')
          }
          this.setState({ displayScrollDownBtn: displayScrollDownBtn })
        } else {
          setTimeout(() => {
            if (!this.scrollBlock) {
              this.scrollBlock = false
            }
          }, 500)
        }
      }, 500)

    }
  }
  showPollItem(currentMsg) {
    let flagPollItem = false
    if (currentMsg.type === 17) {
      try {
        // let attachments = JSON.parse(rxaget(currentMsg, 'attachments', '').replace(/\\/g, '\\\\'))
        let attachments = getAttachments(currentMsg)
        let poll_type = attachments.poll_type
        if (poll_type !== 2 && poll_type !== 3 && poll_type !== 4 && currentMsg.status !== 4) {
          flagPollItem = true
        }
      } catch (e) {
        console.log(e)
      }
    }
    return flagPollItem
  }

  onClickMouseRight(e, omess) {
    const menuDiv = document.getElementById('menu-message')

    const menuDivGroup = document.getElementById('context_menu-group')
    let flagShowMenuPopup = false
    if (!([5, 6, 7, 16].indexOf(omess.type) !== -1)) {
      if (omess.type === 17) {
        flagShowMenuPopup = false //this.showPollItem(omess)
      } else {
        flagShowMenuPopup = true
      }
    }
    if (flagShowMenuPopup) {
      if (menuDiv && e.button === 2) {
        if (omess && omess.status !== 4 && rxaget(omess, 'deleted_uins', []).indexOf(this.userid.toString()) === -1) {
          document.oncontextmenu = function () {
            return false;
          }
          // document.getElementById('popup-group').style.display = 'none'
          menuDiv.style.top = (Number(e.clientY) - 100) + 'px'
          menuDiv.style.left = (Number(e.clientX) - 140) + 'px'
          menuDiv.style.display = 'block'

          let newOmess = JSON.parse(JSON.stringify(omess))
          try {
            if ([2, 9].indexOf(newOmess.type) && this.indexImageForward !== -1 && this.strImgForward !== '') {
              let arrImgs = this.strImgForward.split('|')
              if (arrImgs && arrImgs.constructor === Array && arrImgs.length > 0) {
                let arrAttach = [{ width: arrImgs[1], height: arrImgs[2], url: arrImgs[0] }]
                newOmess.attachments = JSON.stringify({ images: arrAttach }).replace(/\\"/g, '"')
                if (newOmess.type === 9) {
                  newOmess.type = 2
                }
              }
            }
          } catch (e) { }

          this.setState({
            mess_selected: newOmess,
            mess_id: omess.message_id.toString(),
            selectedMessId: newOmess.message_id
          }, () => {
            this.indexImageForward = -1
            this.strImgForward = ''
          })

          // hide context-menu on group
          if (menuDivGroup) {
            menuDivGroup.style.top = e.clientY + 'px'
            menuDivGroup.style.left = Number(e.clientX) + 'px'
            menuDivGroup.style.display = 'none'
          }
        }
      }
    }
  }

  handleClickOutside(event) {
    let className = event.target.className

    if (className !== 'menu-option-forward') {
      if (this.state.mess_id && event.button === 0 && event.target.className !== 'menu-option') {
        // if ([1, 2].indexOf(this.state.type_option) === -1) {
        this.setState({
          mess_selected: {},
          mess_id: ''
        })
        // }
      }
    } else {
    }

  }

  chooseOption(e, type) {
    let option = 0
    let popupGroup = false
    let isForwardAudio = false
    if (type === 'reply') {
      option = 1
      this.sendDataToFooter(this.state.mess_selected, option)
      // let elem = document.getElementById('chat-value')
      // if (elem) {
      //   elem.dispatchEvent(new CustomEvent('chooseOption', { detail: { 
      //     mess_selected: this.state.mess_selected,
      //     type_option: option
      //   }}))
      // }

    } else if (type === 'delete_all') {
      let mess_selected = { ...this.state.mess_selected }
      if (mess_selected && mess_selected.type === 17) {
        let pollInfo = JSON.parse(rxaget(this.state, 'mess_selected.attachments', ''))
        this.deleteVote(pollInfo)
        this.deletePollMessage(mess_selected)
        let firstInitPollMess = this.getFirstInitPollMess(this.state.pinedMess, pollInfo.poll_id)
        if (firstInitPollMess && firstInitPollMess.message_id) {
          this.unPinPollMessFirstInit(firstInitPollMess)
        }
        this.setState({ pinedMess: this.pullFromObjMessByPollId(this.state.pinedMess, pollInfo.poll_id) })
      } else {
        this.deleteMessage(true)
      }
      // this.deleteMessage(true)
    } else if (type === 'delete_one') {
      this.deleteMessage(false)
    } else if (type === 'copy') {
      let messCopy = (rxaget(this.state, 'mess_selected.message', ''))
      if (messCopy.indexOf('@') !== -1) {
        let userstag = messCopy.match(/(@\d+\b)/ig)
        if (userstag && userstag.constructor === Array && userstag.length > 0) {
          userstag.forEach(o => {
            let useridtmp = o.replace('@', '') || ''
            if (this.users[useridtmp]) {
              messCopy = messCopy.replace(o, checkNameUser(rxaget(this.users, useridtmp, {})))
            }
          })
        }
      }
      this.copyTextToClipboard(messCopy)
    } else if (type === 'forward') {
      if ((rxaget(this.state, 'mess_selected.type', '')) === 3) {
        isForwardAudio = true
      }
      option = 2
      popupGroup = true

      let elem = document.getElementById('chat-value')
      if (elem) {
        elem.dispatchEvent(new CustomEvent('chooseOption', {
          detail: {
            mess_selected: this.state.mess_selected,
            type_option: option
          }
        }))
      }

    } else if (type === 'share') {
      this.setState({ displayShareScreen: true })
    } else if (type === 'pin') {
      this.pinMessage(true)
    } else if (type === 'unpin') {
      this.unPin(false)
    } else if (type === 'resend-poll') {
      let currentMsg = rxaget(this.state, 'mess_selected', '')

      this.resendPollAction = { flag: true, mess: currentMsg }
      let pollInfo = JSON.parse(rxaget(this.state, 'mess_selected.attachments', ''))
      if (pollInfo && pollInfo.poll_id) {
        pollInfo.currentMsg = currentMsg
        pollInfo.message_id = currentMsg.message_id
        this.setState({ flagPollListOption: false }, async () => {
          await this.sendPollDataToFooter(pollInfo, 'sendPollMess')
          this.updateObjMessDeleted(currentMsg)
          // this.deletePollMessage(this.state.mess_selected)
        })
      }
    } else if (type === 'finish-poll') {
      let currentMsg = rxaget(this.state, 'mess_selected', '')
      let pollInfo = JSON.parse((rxaget(this.state, 'mess_selected.attachments', '')))
      if (pollInfo && pollInfo.poll_id) {
        pollInfo.currentMsg = currentMsg
        this.sendPollDataToFooter(pollInfo, 'finishPoll')
        this.endVote(pollInfo)
      }
    }
    this.setState({ type_option: option, popupGroup: popupGroup, isForwardAudio: isForwardAudio })
  }

  closePopupGroup() {
    this.setState({ popupGroup: false, mess_selected: {}, mess_id: '' }, () => {
      this.indexImageForward = -1
      this.strImgForward = ''
      this.sendDataToFooter({}, 0)
    })
  }

  copyTextToClipboard(text) {
    let textArea = document.createElement('textarea')
    textArea.style.position = 'fixed'
    textArea.style.top = 0
    textArea.style.left = 0
    textArea.style.width = '2px'
    textArea.style.height = '2px'
    textArea.style.padding = 0
    textArea.style.border = 'none'
    textArea.style.outline = 'none'
    textArea.style.boxShadow = 'none'
    textArea.style.background = 'transparent'
    textArea.value = text.replace(/[\t\r\n]/g, '')
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()
    try {
      document.execCommand('copy')
    } catch (err) {
      console.log('Oops, unable to copy')
    }
    document.body.removeChild(textArea)
  }

  deleteMessage(type, pollmess) {
    let omess
    const messages = this.state.messages
    let delete_all
    if (pollmess && pollmess.message_id) {
      omess = pollmess
      delete_all = true
    } else {
      omess = rxaget(this.state, 'mess_selected', {})
      delete_all = type
    }
    const created_at = convertSecondUnix(Number(rxaget(omess, 'created_at', 0)))
    let datetime = timesUnixToDate(created_at, Number(rxaget(omess, 'created_at', 0)))
    const group_id = this.state.group_id
    let groups = rxaget(this.props, 'netaGroups.groups', {})
    let groupObj = groups[group_id]

    try {
      chatDB.groups.get({ group_id: group_id.toString() }).then(groupInDB => {
        if (groupInDB && rxaget(groupInDB, 'last_message.message_id', '') === omess.message_id.toString()) {
          let lastMessage = groupInDB.last_message || {}
          lastMessage.status = 4
          let updateGroup = {
            last_message: lastMessage
          }

          chatDB.groups.update(group_id.toString(), updateGroup).then((updated) => {
            this.props.changeGroupFunc()
          }).catch(e => { })
        }
      })
    } catch (e) { }

    if (omess.message_id && group_id) {
      const msg = {
        group_id: Number(group_id),
        message_id: omess.message_id.toString(),
        delete_all: delete_all
      }
      type && this.unPin(false)
      if (rxio.connected) {
        rxio.socket.emit('delete_message', msg, (data) => {
          if (data && data.result === 0) {
            if (messages[datetime.toString()] && messages[datetime.toString()].data && messages[datetime.toString()].data.constructor === Array) {
              messages[datetime.toString()].data.forEach(mess => {
                if (mess.message_id === omess.message_id) {
                  mess.status = 4
                  chatDB.mess.put(mess, mess.message_id)
                }
              })
              this.setState({ messages: messages })
            }

            if ([2, 3, 4, 12].indexOf(omess.type) !== -1) {
              this.props.netaMediaOneDel(Number(group_id), omess.attachments)
            }
          }
        })
      }

    }
  }

  // unPin(type) {
  //   const group_id = this.state.group_id
  //   var msg = {
  //     group_id: Number(group_id),
  //     unpin_all: type,
  //   }
  //   var username = rxaget(this.state.mess_selected, 'sender_name', checkNameUser(this.users[this.userid]))      
  //   var omess = rxaget(this.state, 'mess_selected', {}),
  //     unpinmess = username + translate(" unpin: ") + omess.message
  //   if (!type) {
  //     msg.message_id = omess.message_id.toString()
  //   }

  //   if (rxio.connected) {
  //     rxio.socket.emit("unpin_message", msg, (data) => {
  //       if (data && data.result === 0) {
  //         if (type) {
  //           this.setState({ pinedMess: {} })
  //           this.props.netaMessPin(group_id, {})
  //           unpinmess = username + translate(" unpin all message") 
  //         }
  //         else {
  //           this.setState({ pinedMess: this.pullFromObjMess(this.state.pinedMess, omess) })
  //         }
  //         this.handleMessage({
  //           created_at: (Math.floor(Date.now()) * 1000).toString(),
  //           attachments: JSON.stringify({
  //             "mediaType": 0,
  //             "pin_message": { type: -1, content: unpinmess }
  //           }),
  //           deleted_uins: [], group_id, group_type: 3, is_encrypted: false, mentioned_all: false,
  //           mentioned_uins: [], message: "",
  //           message_id: (Math.floor(Date.now()) * 1000).toString(),
  //           sender_uin: this.userid,
  //           status: 0, type: 6, version: 0
  //         })
  //       }
  //     })
  //   }
  // }

  unPin(type) {
    const group_id = this.state.group_id
    var msg = {
      group_id: Number(group_id),
      unpin_all: type,
    }
    var omess = rxaget(this.state, 'mess_selected', {})
    if (!type) {
      msg.message_id = omess.message_id.toString()
    }
    if (rxio.connected) {
      rxio.socket.emit("unpin_message", msg, (data) => {
        if (data && data.result === 0) {
          this.createMessage("unpin", type, (paramsCreateMess) => {
            try {
              if (type) {
                this.setState({ pinedMess: {} })
                this.props.netaMessPin(group_id, {})
              } else {
                this.setState({ pinedMess: this.pullFromObjMess(this.state.pinedMess, omess) })
              }
              this.handleMessage({
                created_at: (Math.floor(Date.now()) * 1000).toString(),
                attachments: paramsCreateMess.attachments.replace(/\\"/g, "\""),
                deleted_uins: [], group_id, group_type: 3, is_encrypted: false, mentioned_all: false,
                mentioned_uins: [], message: "",
                message_id: (Math.floor(Date.now()) * 1000).toString(),
                sender_uin: this.userid,
                status: 0, type: 6, version: 0
              })
            } catch (e) {
              console.log(e)
            }
          })
        }
      })
    }
  }
  unPinPollMessFirstInit(omess) {
    const group_id = this.state.group_id
    var msg = {
      group_id: Number(group_id),
      unpin_all: false,
    }
    msg.message_id = omess.message_id.toString()

    if (rxio.connected) {
      rxio.socket.emit("unpin_message", msg, (data) => {
        if (data && data.result === 0) {
        }
      })
    }
  }

  unPinPoll(pollInfo, action) {
    const group_id = this.state.group_id
    var msg = {
      group_id: Number(group_id),
      unpin_all: false,
    }
    msg.message_id = pollInfo.message_id.toString()

    if (rxio.connected) {
      rxio.socket.emit("unpin_message", msg, (data) => {
        if (data && data.result === 0) {
          if (action !== 'resend-poll')
            this.createMessage("unpin", false, (paramsCreateMess) => {
              try {
                this.setState({ pinedMess: this.pullFromObjMess(this.state.pinedMess, pollInfo), flagPollListOption: false })
                this.handleMessage({
                  created_at: (Math.floor(Date.now()) * 1000).toString(),
                  attachments: paramsCreateMess.attachments.replace(/\\"/g, "\""),
                  deleted_uins: [], group_id, group_type: 3, is_encrypted: false, mentioned_all: false,
                  mentioned_uins: [], message: "",
                  message_id: (Math.floor(Date.now()) * 1000).toString(),
                  sender_uin: this.userid,
                  status: 0, type: 6, version: 0
                })
              } catch (e) {
                console.log(e)
              }
            })
        }
      })
    }
  }


  checkPinMess() {
    var checkCode = 0
    try {
      const data = this.state.mess_selected
      if ([5, 6].indexOf(data.type) === -1) {
        checkCode = 1
        for (const key in this.state.pinedMess) {
          const messages = this.state.pinedMess[key]
          messages.data.some(o => o.message_id === data.message_id) && (checkCode = 2)
        }
        return checkCode
      } else return checkCode

    } catch (error) {
      console.log("error", error)
      return checkCode
    }
  }

  checkPinMessById(mess_id) {
    let checkCode = 0
    try {
      checkCode = 1
      for (const key in this.state.pinedMess) {
        const messages = this.state.pinedMess[key]
        messages.data.some(o => o.message_id === mess_id) && (checkCode = 2)
      }
      return checkCode
    } catch (error) {
      console.log("error", error)
      return checkCode
    }
  }

  pullFromObjMess(messages, data) {
    try {
      for (const key in messages) {
        if (messages[key] && messages[key].data) {
          messages[key].data = messages[key].data.filter(o => o.message_id !== data.message_id)
          if (messages[key].data && messages[key].data.length === 0) {
            delete messages[key]
          }
        }
      }
    } catch (e) {
      console.log(e)
    }
    return messages
  }

  pullFromObjMessByPollId(messages, poll_id) {
    try {
      for (const key in messages) {
        if (messages[key] && messages[key].data) {
          messages[key].data = messages[key].data.filter(omess => {
            // let attachments   = JSON.parse(rxaget(omess, 'attachments', ''))
            let attachments = getAttachments(omess)
            return attachments?.poll_id !== poll_id
          })
          if (messages[key].data && messages[key].data.length === 0) {
            delete messages[key]
          }
        }
      }
    } catch (e) {
      console.log(e)
    }

    return messages
  }

  getFirstInitPollMess(messages, poll_id) {
    let mess
    try {
      for (const key in messages) {
        if (messages[key] && messages[key].data) {
          let pollMess = messages[key].data.filter(omess => {
            // let attachments   = JSON.parse(rxaget(omess, 'attachments', ''))
            let attachments = getAttachments(omess)
            return attachments.poll_id === poll_id
          })
          mess = pollMess[0]
        }
      }
    } catch (e) {
      console.log(e)
    }


    return mess
  }

  pushToObjMess(messages, data, sortField = 'created_at') {
    try {
      const datetime = timeToDate(Math.floor(Number(rxaget(data, sortField, 0)) / 1000000))
      if (messages[datetime.toString()] && messages[datetime.toString()].data) {
        const arrMess = messages[datetime.toString()].data.filter(o => o.message_id !== data.message_id)
        arrMess.push(data)
        messages[datetime.toString()].data = arrMess.sort((a, b) => Number(a[sortField]) < Number(b[sortField]) ? -1 : 1)
      } else {
        if (!messages[datetime.toString()]) {
          messages[datetime.toString()] = { date: datetime, datestr: timeConverter(datetime, 'dateweek') }
        }
        if (messages[datetime.toString()] && !messages[datetime.toString()].data) {
          messages[datetime.toString()].data = [data]
        }
      }
    } catch (e) {
      console.log(e)
    }
    return messages
  }

  // pinMessage(type) {
  //   let omess = rxaget(this.state, 'mess_selected', {})
  //   const group_id = this.state.group_id
  //   const msg = {
  //     group_id: Number(group_id),
  //     message_id: omess.message_id.toString(),
  //     "order_id": 1
  //   }
  //   omess.pinned_at = (Math.floor(Date.now()) * 1000).toString()
  //   if (rxio.connected) {
  //     rxio.socket.emit('pin_message', msg, (data) => {
  //       if (data && data.result === 0) {
  //         var ownerSend = this.users[omess.sender_uin],
  //           userSend = this.users[this.userid],
  //           paramsCreateMess = {
  //             "group_id": group_id, "nonce": (Math.floor(Date.now()) * 1000).toString(), "sender_name": checkNameUser(userSend),
  //             "type": 6, "version": 1, "is_encrypted": false, "mentioned_all": false,
  //             "sender_avatar": (userSend && userSend.profile_url) ? global.rxu.config.cdn_endpoint + userSend.profile_url : '',
  //             "attachments": JSON.stringify({
  //               "mediaType": 0,
  //               "pin_message": {
  //                 "id": rxaget(omess, 'message_id').toString(),
  //                 "groupId": group_id, "type": rxaget(omess, 'type'), "content": rxaget(omess, 'message'),
  //                 "owner": {
  //                   "id": rxaget(ownerSend, 'id'), "username": rxaget(omess,'sender_name'),
  //                   "avatar": rxaget(omess, 'sender_avatar'),
  //                   "phone": rxaget(ownerSend, 'phone'), "isonline": false, "email": rxaget(ownerSend, 'email'),
  //                   "coloringroup": 7,
  //                   "isregistered": false, "isblocked": false, "isdeleted": false
  //                 }, "created_at": rxaget(omess, 'created_at'),
  //                 "sendername": checkNameUser(userSend),
  //                 "senderavatar": (userSend && userSend.profile_url) ? global.rxu.config.cdn_endpoint + userSend.profile_url : '',
  //                 "updateat": 0, "status": 1,
  //                 "version": "1", "messageUpdate": "", "isEncrypted": false, "isMentionAll": false
  //               }
  //             }).replace(/"/g, '\\"')
  //           }
  //         rxio.socket.emit('create_message', paramsCreateMess, (dataMess) => {
  //           if (dataMess && dataMess.result === 0) {
  //             try {
  //               this.handleMessage({
  //                 created_at: (Math.floor(Date.now()) * 1000).toString(),
  //                 attachments: paramsCreateMess.attachments.replace(/\\"/g, "\""),
  //                 deleted_uins: [], group_id, group_type: 3, is_encrypted: false, mentioned_all: false,
  //                 mentioned_uins: [], message: "",
  //                 message_id: Number(omess.pinned_at),
  //                 sender_uin: this.userid,
  //                 status: 0, type: 6, version: 0
  //               })
  //               this.setState({ pinedMess: this.pushToObjMess(JSON.parse(JSON.stringify(this.state.pinedMess)), omess, "pinned_at") })
  //             } catch (e) {
  //               console.log(e)
  //             }
  //           }
  //         })
  //       }
  //     })
  //   }
  // }

  pinMessage(type) {
    const group_id = this.state.group_id
    let omess = rxaget(this.state, 'mess_selected', {})
    omess.pinned_at = (Math.floor(Date.now()) * 1000).toString()
    const msg = {
      group_id: Number(group_id),
      message_id: omess.message_id.toString(),
      "order_id": 1
    }
    if (rxio.connected) {
      rxio.socket.emit('pin_message', msg, (data) => {
        if (data && data.result === 0) {
          this.createMessage("pin", null, (paramsCreateMess) => {
            try {
              this.handleMessage({
                created_at: (Math.floor(Date.now()) * 1000).toString(),
                attachments: paramsCreateMess.attachments.replace(/\\"/g, "\""),
                deleted_uins: [], group_id, group_type: 3, is_encrypted: false, mentioned_all: false,
                mentioned_uins: [], message: "",
                message_id: Number(omess.pinned_at),
                sender_uin: this.userid,
                status: 0, type: 6, version: 0
              })
              this.setState({ pinedMess: this.pushToObjMess(JSON.parse(JSON.stringify(this.state.pinedMess)), omess, "pinned_at") })
            } catch (e) {
              console.log(e)
            }
          })
        }
      })
    }
  }

  repinPoll(omess) {
    const group_id = this.state.group_id
    // let omess = rxaget(this.state, 'mess_selected', {})
    omess.pinned_at = (Math.floor(Date.now()) * 1000).toString()
    const msg = {
      group_id: Number(group_id),
      message_id: omess.message_id.toString(),
      "order_id": 1
    }
    if (rxio.connected) {
      rxio.socket.emit('pin_message', msg, (data) => {
        if (data && data.result === 0) {
          this.setState({ pinedMess: this.pushToObjMess(JSON.parse(JSON.stringify(this.state.pinedMess)), omess, "pinned_at") })
        }
      })
    }
  }



  createMessage(type, unpin_all, callback) {
    const group_id = this.state.group_id
    let omess = rxaget(this.state, 'mess_selected', {})
    var message = ""
    switch (omess.type) {
      case 2: message = "Images"; break;
      case 3: message = "Audio record"; break;
      case 4: message = "Video"; break;
      case 12: message = "Documents"; break;
      case 17:
        // let attachments = JSON.parse(rxaget(omess, 'attachments', ''))
        let attachments = getAttachments(omess)
        message = { attachments: attachments };
        break;
      default: message = omess.message; break;
    }
    var userSend = rxaget(this.users, this.userid, {}),
      paramsCreateMess = {
        "group_id": group_id, "nonce": (Math.floor(Date.now()) * 1000).toString(), "sender_name": checkNameUser(userSend),
        "type": 6, "version": 1, "is_encrypted": false, "mentioned_all": false,
        "sender_avatar": (userSend && userSend.profile_url) ? global.rxu.config.cdn_endpoint + userSend.profile_url : '',
        "attachments": JSON.stringify({
          "pin_message": {
            "message": message,
            "type": omess.type
          }
        }).replace(/"/g, '\\"')
      }
    if (type === "pin") {
      paramsCreateMess["attachments"] = JSON.stringify({ "pin_message": { "message": message, "type": omess.type } }).replace(/"/g, '\\"')
    } else if (type === "unpin" && !unpin_all) {
      paramsCreateMess["attachments"] = JSON.stringify({ "unpin_message": { "message": message, "type": omess.type } }).replace(/"/g, '\\"')
    } else if (type === "unpin" && unpin_all) {
      paramsCreateMess["attachments"] = JSON.stringify({ "stickerType": 0, "type": "group_update", "unpin_all_messages": true }).replace(/"/g, '\\"')
    }

    rxio.socket.emit('create_message', paramsCreateMess, (dataMess) => {
      if (dataMess && dataMess.result === 0) {
        callback && callback(paramsCreateMess)
      }
    })
  }



  removeMess(messid) {
    const group_id = this.state.group_id
    const messages = this.state.messages
    messid = messid || ''

    let datetime = 0
    try {
      let newMessId = Math.floor(Number(messid) / 1000000)
      if (newMessId.toString().length < 9) {
        newMessId = Math.floor(Number(messid) / 1000)
      }
      datetime = ((newMessId + 25200) - (newMessId + 25200) % (86400)) - 25200
      if (messages[datetime.toString()] && messages[datetime.toString()].data) {
        let findMess = messages[datetime.toString()].data.find(o => o.message_id === messid)
        if (findMess) {
          findMess.callback(messid)
          messages[datetime.toString()].data = messages[datetime.toString()].data.filter(o => o.message_id !== messid)

          this.setState({ messages: messages }, () => {
            findMess.callback(messid)
          })
        } else {
          let findMessIndex = this.arrFilesTmp.findIndex(o => o.message_id === messid)
          let findMess2 = this.arrFilesTmp[findMessIndex]

          findMess2.callback(messid)
          this.arrFilesTmp.splice(findMessIndex, 1)
          this.setState({ messages: messages }, () => {
            findMess2.callback(messid)
          })
        }
      }
    } catch (e) {
      console.log(e)
    }
  }

  handleMessage(data, scroll, cond) {
    if (this.disableScrollDown) {
      const group_id = this.state.group_id
      const messages = JSON.parse(JSON.stringify(this.state.messages))
      const messid = rxaget(data, 'message_id', '')
      const created_at = convertSecondUnix(Number(rxaget(data, 'created_at', 0)))
      const datetime = timesUnixToDate(created_at, Number(rxaget(data, 'created_at', 0)))

      if (data && data.reactions) {
        //update reactions:
        Object.keys(messages).forEach(odate => {
          messages[odate].data.forEach((msg) => {
            if (msg.message_id === messid) {
              msg.reactions = data.reactions;
              this.setState({ messages });
              return;
            }
          })
        });
      }

      if (messid && datetime > 0 && data) {
        if (data && data.group_id && group_id && (data.group_id.toString() === group_id.toString())) {
          try {
            if (messages[datetime.toString()] && messages[datetime.toString()].data) {
              const arrMess = messages[datetime.toString()].data.filter(o => o.message_id !== data.message_id)
              const lastmess = arrMess[arrMess.length - 1]

              if (data && data.sender_uin && lastmess && lastmess.sender_uin && !lastmess.checked_ava) {
                if ((data.sender_uin === lastmess.sender_uin) && ((Number(lastmess.created_at) - Number(data.created_at)) < 60000000)) {
                  data.checked_ava = true
                }
              }

              if (arrMess.length > 40) {
                arrMess.shift()
              }
              arrMess.push(data)
              messages[datetime.toString()].data = arrMess.sort((a, b) => Number(a.created_at) < Number(b.created_at) ? -1 : 1)
            } else {
              if (!messages[datetime.toString()]) {
                messages[datetime.toString()] = { date: datetime, datestr: timeConverter(datetime, 'dateweek') }
              }
              if (messages[datetime.toString()] && !messages[datetime.toString()].data) {
                messages[datetime.toString()].data = [data]
              }
            }

            let stateObj = { messages: messages }
            if (cond === 'footer') {
              stateObj['type_option'] = 0
              stateObj['mess_selected'] = {}
              stateObj['mess_id'] = {}
            }

            try {
              chatDB.groups.get({ group_id: group_id }).then(groupInDB => {
                if (groupInDB) {
                  let showNoti = this.checkGroupsAdminLeave(groupInDB, data)
                  if (showNoti) {
                    let paramsUpdateGroup = {
                      last_message: data,
                      last_message_id: data.message_id,
                      last_sort: '1' + groupInDB.flagDraf + groupInDB.flagPin + data.created_at,
                      count_unread: 0
                    }
                    workerUnread.initUnread(groupInDB.group_id.toString(), '-1')
                    chatDB.groups.update(rxaget(groupInDB, 'group_id', '').toString(), paramsUpdateGroup).then(o => {
                      this.props.changeGroupFunc()
                    }).catch(e => { })

                    // this.setState(stateObj, () => {
                    //   if (scroll) {
                    //     const chatDiv = document.getElementById('zchat_list')
                    //     if (chatDiv) {
                    //       if (this.state.displayScrollDownBtn === false || data.sender_uin === String(this.userid) || chatDiv.scrollHeight - chatDiv.scrollTop < window.screen.height/*511 + 150*/) {
                    //         chatDiv.scrollTop = chatDiv.scrollHeight
                    //       }
                    //     }  
                    //   }              
                    // })
                  }
                }
              })
            } catch (e) {
              console.log(e)
            }


            this.setState(stateObj, () => {
              if (scroll) {
                const chatDiv = document.getElementById('zchat_list')
                if (chatDiv) {
                  if (this.state.displayScrollDownBtn === false || data.sender_uin === String(this.userid) || chatDiv.scrollHeight - chatDiv.scrollTop < window.screen.height/*511 + 150*/) {
                    chatDiv.scrollTop = chatDiv.scrollHeight
                  }
                }
              }
            })
          } catch (e) {
            console.log(e)
          }
        }

      }

      this.handleNoti(data)
    }
  }

  async handleNoti(data) {
    if (data) {
      try {
        let netalo_noti = JSON.parse(window.sessionStorage.getItem("netalo_noti") || '{}')
        if (!netalo_noti[data.message_id] &&
          (!this.countNoti[data.group_id] || !this.countNoti[data.group_id][data.message_id])) {
          if (!(data.type === 10 && !data.attachments) && data.sender_uin.toString() !== this.userid.toString()) {
            let userSend = worker.users[data.sender_uin]
            let groupTmp = await chatDB.groups.get({ group_id: data.group_id })

            let sender_name = ''
            if (groupTmp.type === 3) {
              sender_name = checkNameUser(userSend)
            } else {
              sender_name = groupTmp.name
            }
            let objNoti = {
              group_id: data.group_id,
              current_group_id: this.state.group_id || '',
              message_id: data.message_id,
              message: subString(parseMessageDesc(data, this.users, this.userid), 60),
              sender_uin: data.sender_uin,
              sender_name: sender_name,
              sender_ava: (userSend && userSend.profile_url) ? global.rxu.config.cdn_endpoint + userSend.profile_url : ''
            }
            let showNoti = true
            try {
              if (groupTmp && groupTmp.type !== 3 && groupTmp.admin_uins && groupTmp.admin_uins.constructor === Array && (groupTmp.admin_uins.indexOf(this.userid.toString()) === -1 || groupTmp.owner_uin.toString() !== this.userid.toString()) && data.type === 7) {
                showNoti = false
              }
            } catch (e) {
            }

            if (showNoti) {
              try {
                let groupObjTmp = this.groups[objNoti['group_id']]
                if (groupObjTmp && groupObjTmp['type'] === 2) {
                  objNoti['sender_name'] = checkNameGroup(groupObjTmp, this.users, this.userid)
                  objNoti['sender_ava'] = (groupObjTmp.avatar_url) ? global.rxu.config.cdn_endpoint + groupObjTmp.avatar_url : ''
                }
              } catch (e2) { }

              let notificationStatus = rxgetLocal('netaNotificationStatus')
              let netaAuthSetting = JSON.parse(localStorage.getItem('netaAuthSetting') || `{"groups":{}}`)
              if (netaAuthSetting.groups[Number(data.group_id)]
                && netaAuthSetting.groups[Number(data.group_id)].disableNoti)
                notificationStatus = false
              if (objNoti.message && notificationStatus === JSON.stringify(true)) {
                if (rxaget(data, 'message_id', '')) {
                  chatDB.noti.get(Number(data.group_id)).then(async (result) => {
                    try {
                      if (typeof (result) === 'undefined') {
                        await chatDB.noti.add({ group_id: Number(data.group_id) })
                      }

                      let cntNoti = await chatDB.noti.count()
                      objNoti['total'] = cntNoti
                      if (isElectron()) {
                        window.ipcRenderer.send('notification', objNoti)
                      } else {
                        if (window.Notification && Notification.permission !== "denied"
                          && rxaget(data, 'sender_uin', '').toString() !== this.userid.toString()
                          && data.message_id
                        ) {
                          let notification = new Notification(objNoti.sender_name, {
                            body: objNoti.message,
                            icon: objNoti.sender_ava,
                            data: objNoti
                          });
                          notification.onclick = () => {
                            this.props.callBackRedirectChat()

                            chatDB.groups.get({ group_id: objNoti.group_id }).then(groupNoti => {

                              groupNoti.count_unread = 0
                              groupNoti.unread_cnt = 0
                              groupNoti.isTagnameInMess = false
                              this.chooseGroup(groupNoti)

                              this.props.chooseGroupAction(groupNoti)
                              window.focus();

                            })
                          };
                        }
                      }
                    } catch (e) { }
                  }).catch((e) => { })
                }
              }
            }
          }
        }
      } catch (e) {
        // console.log(e)
      }


    }
  }

  checkSticker(sticker, imgsticker) {
    let arrTabsDisplay = this.state.arrTabsDisplay
    for (let i = 0; i < arrTabsDisplay.length; i++) {
      if (arrTabsDisplay[i].type === sticker && arrTabsDisplay[i].data.indexOf(imgsticker) === -1) {
        return false
      }
    }
    return true
  }

  fetchGroupDetail(group_id, flagAddGroup) {
    if (group_id && this.token) {
      const api_group_detail = global.rxu.config.get_groups + '/' + group_id
      fetch(api_group_detail, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'TC-Token': this.token,
          Connection: 'Keep-Alive',
          'Accept-Encoding': 'gzip'
        },
        body: null
      })
        .then(res => res.json())
        .then((json) => {
          if (json && json.users && json.users.constructor === Array && json.users.length > 0) {
            try {
              let ogroup = rxaget(json, 'Group', {})
              ogroup.timestamp = (ogroup.last_message && ogroup.last_message.created_at) ? Number(ogroup.last_message.created_at) : (ogroup.updated_at) ? ogroup.updated_at : new Date().getTime() * 1000
              ogroup.flagDraf = (ogroup.flagDraf) ? ogroup.flagDraf : '0' // 0 or 1
              ogroup.flagPin = (ogroup && ogroup.pinned_uins && ogroup.pinned_uins.indexOf(this.userid.toString()) !== -1) ? '1' : '0'
              ogroup.last_sort = '1' + ogroup.flagDraf + ogroup.flagPin + ogroup.timestamp

              ogroup.received_list = []
              ogroup.seen_list = []
              ogroup.occupants_uins = ogroup.occupants_uins.map(String)

              const arrUins = rxaget(ogroup, 'occupants_uins', [])

              ogroup['partner_id'] = 0
              ogroup['avatar_url'] = ogroup.avatar_url || ''

              let objUsers = []
              let arrNameTmp = []
              if (json.users && json.users.constructor === Array && json.users.length > 0) {
                for (const user of json.users) {
                  if (!(rxaget(user, 'full_name', '') || rxaget(user, 'phone', ''))) {
                    user.full_name = translate('Stranger')
                  }
                  objUsers.push({ id: user.Id, uid: user.Id, ...user })

                  let uName = rxaget(user, 'full_name', '') || rxaget(user, 'phone', '')
                  if (uName) {
                    arrNameTmp.push(uName)
                  }

                  this.users[user.Id] = { id: user.Id, uid: user.Id, ...user }
                  worker.addUser(user.Id, { id: user.Id, uid: user.Id, ...user })

                }
              }
              if (json.removed_users && json.removed_users.constructor === Array && json.removed_users.length > 0) {
                for (const user of json.removed_users) {
                  worker.addUser(user.Id, { id: user.Id, uid: user.Id, ...user })
                  if (rxaget(user, 'full_name', '') || rxaget(user, 'phone', '')) {
                    objUsers.push({ id: user.Id, uid: user.Id, ...user })
                  }
                }
              }
              if (json.Group && json.Group.group_id.toString()) {
                chatDB.users.bulkPut(objUsers)
              }

              ogroup['group_fullname'] = ogroup.name || arrNameTmp.slice(0, 3).join(', ')

              ogroup.count_unread = 0
              ogroup.group_id = ogroup.group_id.toString()

              if (rxaget(this.state.group, 'group_id', '') === ogroup.group_id.toString()) {
                this.setState({
                  changeListMess: true
                })
              }

              if (!flagAddGroup) {
                workerUnread.initUnread(ogroup.group_id.toString(), '-1')
                chatDB.groups.add(ogroup, ogroup.group_id.toString()).then(g => {
                  this.props.changeGroupFunc()
                }).catch(e => {
                  console.log(e)
                })
              }
            } catch (e) { }

          }
        }).catch(error => console.log(error))
    }
  }

  loadMessages(oldheight, type) {
    let group_id = this.state.group_id
    let msg = {
      group_id: group_id,
      psize: 30
    }

    if (type === 'up') {
      msg['last_message_id'] = this.firstMessUpId
      msg['direction'] = 0
      msg['pindex'] = 0
    } else if (type === 'down') {
      msg['last_message_id'] = this.lastMessDownId
      msg['direction'] = 1
      msg['pindex'] = 0
    }

    this.checkImage = this.checkImage || {}
    const objDate = this.state.messages || {}
    if (rxio.connected) {
      rxio.socket.emit('list_message', msg, (data) => {
        if (data && data.last_message_id && data.messages && data.messages.constructor === Array && data.messages.length > 0) {
          let messages = []
          if (type === 'up') {
            messages = data.messages.sort((a, b) => Number(a.created_at) > Number(b.created_at) ? -1 : 1)
            this.firstMessUpId = messages[messages.length - 1]['message_id']
          } else if (type === 'down') {
            messages = data.messages.sort((a, b) => Number(a.created_at) > Number(b.created_at) ? 1 : -1)
            this.lastMessDownId = messages[messages.length - 1]['message_id']

            if (!this.flagSearchMess) {
              this.checkReadedOne(group_id, this.lastMessDownId)
            }

            if (messages.length < 30) {
              this.disableScrollDown = true
              this.flagSearchMess = false
            }
          }

          for (const imess in messages) {
            const omess = messages[imess]
            if ((imess < (messages.length - 2)) && [5, 6, 7].indexOf(omess.type) === -1) {
              const newomess = messages[Number(imess) + 1]
              if (omess.sender_uin && newomess.sender_uin && !newomess.checked_ava) {
                if ((omess.sender_uin === newomess.sender_uin) && ((Number(newomess.created_at) - Number(omess.created_at)) < 60000000)) {
                  messages[Number(imess) + 1].checked_ava = true
                }
              }
            }
            if (omess && omess.created_at) {
              const created_at = convertSecondUnix(Number(omess.created_at))
              const date = timesUnixToDate(created_at, Number(omess.created_at))
              if (!objDate[date]) { objDate[date] = { data: [], date: date, datestr: timeConverter(date, 'dateweek') } }
              const findMess = objDate[date].data.find(o => o.message_id === omess.message_id)
              if (!findMess) {
                if (type === 'up') {
                  objDate[date].data.unshift(omess)
                } else if (type === 'down') {
                  objDate[date].data.push(omess)
                }
              }
            }
          }
          this.setState({ messages: objDate }, () => {
            const chatListDiv = document.getElementById('zchat_list')
            if (chatListDiv) {
              try {
                if (type === 'up') {
                  if (chatListDiv.scrollHeight && (chatListDiv.scrollHeight - oldheight) > 0) {
                    chatListDiv.scrollTop = chatListDiv.scrollHeight - oldheight
                  }
                } else if (type === 'down' && !this.flagSearchMess) {
                  chatDB.groups.get({ group_id: group_id.toString() }).then(groupInDB => {
                    if (groupInDB) {
                      let dataUpdate = { my_seen_mess: this.lastMessDownId }
                      if (data.messages.length < 30) {
                        dataUpdate['count_unread'] = 0
                      } else {
                        dataUpdate['count_unread'] = (!isNaN(groupInDB['count_unread']) && !isNaN(data.messages.length) && (Number(groupInDB['count_unread']) - Number(data.messages.length)) >= 0) ? (Number(groupInDB['count_unread']) - Number(data.messages.length)) : 0
                      }

                      if (dataUpdate['count_unread'] > 0) {
                        let typeFolder = (groupInDB.folders && groupInDB.folders.constructor === Array && groupInDB.folders.length > 0) ? groupInDB.folders[0] : '2'
                        workerUnread.initUnread(groupInDB.group_id.toString(), typeFolder)
                      } else {
                        workerUnread.initUnread(groupInDB.group_id.toString(), '-1')
                      }

                      chatDB.groups.update(group_id.toString(), dataUpdate).then((updated) => {
                        this.props.changeGroupFunc()
                      }).catch(e => {
                        console.log(e)
                      })
                    }
                  })
                }

                if (!this.flagSearchMess) {
                  chatDB.mess.bulkPut(messages).then(result => { }).catch(e => { console.log(e) })
                }
              } catch (e) { }
            }
          })
        } else {
          this.disableScrollDown = true
          this.flagSearchMess = false
          this.setState({ scroll_mess: false })
        }
      })

      setTimeout(() => {
        this.scrollBlock = false
        this.scrollDownBlock = false
      }, 800)
    }
  }

  checkGroupsAdminLeave(groupTmp, mess) {
    let showNoti = true
    try {
      if (groupTmp && groupTmp.type !== 3 && groupTmp.admin_uins && groupTmp.admin_uins.constructor === Array && (groupTmp.admin_uins.indexOf(this.userid.toString()) === -1 || groupTmp.owner_uin.toString() !== this.userid.toString()) && mess && mess.type === 7) {
        showNoti = false
      }
    } catch (e) {
    }
    return showNoti
  }

  async chooseGroup(group) {
    if (group && group.group_id) {
      const group_id = group.group_id

      let messInDB = chatDB.mess.where('group_id').equals(group_id.toString())
      let countDB = await messInDB.count()
      let indexData = (countDB >= 30) ? countDB - 30 : 0
      let newMessInDB = await messInDB.offset(indexData).toArray()

      let netaMess = newMessInDB

      let netaPinMess = this.props.netaPinMess

      let netaGroupsLastMess = global.rxu.json(rxgetLocal('netaGroupsLastMess'), {})
      let last_message_id_tmp
      if (typeof netaGroupsLastMess !== 'undefined' && typeof netaGroupsLastMess.groups !== 'undefined' && typeof netaGroupsLastMess.groups[group.group_id] !== 'undefined') {

        last_message_id_tmp = netaGroupsLastMess.groups[group.group_id].last_message_id

      } else {
        last_message_id_tmp = group.last_message_id
      }

      let mySeenMess = ''
      let groupInDB = await chatDB.groups.get(group_id.toString())
      if (groupInDB) {
        if (!this.groupSeenLast[group_id]) {
          this.groupSeenLast[group_id] = groupInDB.another_seen_mess
        }

        if (groupInDB.my_seen_mess) {
          mySeenMess = groupInDB.my_seen_mess
        } else {
          mySeenMess = (groupInDB && groupInDB.last_message_id) ? groupInDB.last_message_id.toString() : ''
        }
      }

      if (!mySeenMess && group && group.last_message_id) {
        mySeenMess = group.last_message_id.toString()
        groupInDB = group
      }

      const msg = {
        group_id: group_id,
        pindex: 0,
        psize: 30
      }
      let objMessTmp = {}
      if (group_id && netaMess && netaMess.length) {
        for (let oMess of netaMess) {
          const keyCreate = oMess.created_at
          const createdAt = convertSecondUnix(Number(keyCreate))
          const dateTmp = timesUnixToDate(createdAt, Number(keyCreate))

          let flagShow = this.checkGroupsAdminLeave(groupInDB, oMess)
          if (flagShow) {
            if (!objMessTmp[dateTmp]) { objMessTmp[dateTmp] = { data: [], date: dateTmp, datestr: timeConverter(dateTmp, 'dateweek') } }
            objMessTmp[dateTmp]['data'].push(oMess)
          }
        }
      }
      let objMessPin = {}
      if (group_id && netaPinMess && netaPinMess['data'] && netaPinMess['data'][group_id.toString()] && netaPinMess['data'][group_id.toString()]['messages']) {
        for (let keyCreate of Object.keys(netaPinMess['data'][group_id.toString()]['messages'])) {
          const createdAt = convertSecondUnix(Number(keyCreate))
          const dateTmp = timesUnixToDate(createdAt, Number(keyCreate))
          if (!objMessPin[dateTmp]) { objMessPin[dateTmp] = { data: [], date: dateTmp, datestr: timeConverter(dateTmp, 'dateweek') } }
          objMessPin[dateTmp]['data'].push(netaPinMess['data'][group_id.toString()]['messages'][keyCreate])
        }
      }
      this.checkImage = {}
      this.pg_mess = 0
      this.pg_down_mess = 0
      this.firstMessUpId = ''
      this.lastMessDownId = ''
      this.disableScrollDown = true
      this.flagSearchMess = false

      this.setState({ popupGroup: false, group_id: group_id, group: group, messages: objMessTmp, pinedMess: objMessPin, scroll_mess: false, mess: '' }, () => {
        const chatDiv = document.getElementById('zchat_list')
        if (chatDiv) {
          chatDiv.scrollTop = chatDiv.scrollHeight
        }
        if (rxio.connected) {
          const getObjMess = (data, sortField = 'created_at') => {
            let objUsers = {}
            let messArrProps = []
            const objDate = {}
            if (data && data.messages) {
              const messages = data.messages.sort((a, b) => Number(a[sortField]) < Number(b[sortField]) ? -1 : 1)
              let arrUsers = []
              for (const imess in messages) {
                const omess = messages[imess]
                if ((imess < (messages.length - 2)) && [5, 6, 7].indexOf(omess.type) === -1) {
                  const newomess = messages[Number(imess) + 1]
                  if (omess.sender_uin && newomess.sender_uin && !newomess.checked_ava) {
                    if ((omess.sender_uin === newomess.sender_uin) && ((Number(newomess[sortField]) - Number(omess[sortField])) < 60000000)) {
                      messages[Number(imess) + 1].checked_ava = true
                    }
                  }
                }
                if (omess && omess[sortField]) {
                  const created_at = convertSecondUnix(Number(omess[sortField]))
                  const date = timesUnixToDate(created_at, Number(omess[sortField]))
                  if (!objDate[date]) { objDate[date] = { data: [], date: date, datestr: timeConverter(date, 'dateweek') } }
                  objDate[date].data.push(omess)
                  messArrProps.push(omess)
                }

                let senderName = rxaget(omess, 'sender_name', '')
                if (senderName) {
                  const objreg = {
                    id: Number(rxaget(omess, 'sender_uin', '')),
                    uid: Number(rxaget(omess, 'sender_uin', '')),
                    email: '',
                    phone: '',
                    full_name: rxaget(omess, 'sender_name', ''),
                    profile_url: '',
                    name_contact: ''
                  }

                  if (!objUsers[objreg.uid] && objreg.uid !== this.userid) {
                    arrUsers.push(arrUsers)
                    chatDB.users.get(Number(objreg.uid)).then(u => {
                      if (!u || !u.full_name) {
                      }
                    })
                  }
                  objUsers[objreg.uid] = objreg
                }
              }
            }


            let arrUsersId = Object.keys(objUsers).map(o => Number(o))
            return { objDate, messArrProps }
          }

          if (mySeenMess && mySeenMess.length > 5) {
            try {
              // Lấy dưới
              let msgOld = {
                group_id: group_id,
                last_message_id: mySeenMess,
                direction: 0,
                pindex: 0,
                psize: 30
              }

              // Lấy trên
              let msgNew = {
                group_id: group_id,
                last_message_id: mySeenMess,
                direction: 1,
                pindex: 0,
                psize: 15
              }

              rxio.socket.emit('list_message', msgOld, (dataOld) => {
                rxio.socket.emit('list_message', msgNew, (dataNew) => {
                  let newMySeenMessId = mySeenMess.slice(0, -4) + (Number(mySeenMess.slice(-4)) + 1)
                  let timeLastSeen = (dataOld && dataOld.messages.constructor === Array && dataOld.messages.length > 0 && dataOld['messages'][0] && dataOld['messages'][0]['created_at']) ? dataOld['messages'][0]['created_at'] : 0

                  this.firstMessUpId = ''
                  this.lastMessDownId = ''

                  if (dataNew && dataNew['messages'].constructor === Array && dataNew['messages'].length > 0) {
                    this.lastMessDownId = dataNew['messages'][dataNew['messages'].length - 1]['message_id']

                    if (this.lastMessDownId && group.occupants_uins && group.occupants_uins.length < maxUser) {
                      this.checkReadedOne(group_id, this.lastMessDownId)

                      let dataUpdate = { my_seen_mess: this.lastMessDownId }
                      if (dataNew['messages'].length < 15) {
                        dataUpdate['count_unread'] = 0
                      } else {
                        dataUpdate['count_unread'] = (!isNaN(groupInDB['count_unread']) && !isNaN(dataNew['messages'].length) && (Number(groupInDB['count_unread']) - Number(dataNew['messages'].length)) >= 0) ? (Number(groupInDB['count_unread']) - Number(dataNew['messages'].length)) : 0
                      }

                      if (dataUpdate['count_unread'] > 0) {
                        let typeFolder = (groupInDB.folders && groupInDB.folders.constructor === Array && groupInDB.folders.length > 0) ? groupInDB.folders[0] : '2'
                        workerUnread.initUnread(groupInDB.group_id.toString(), typeFolder)
                      } else {
                        workerUnread.initUnread(groupInDB.group_id.toString(), '-1')
                      }

                      chatDB.groups.update(group_id.toString(), dataUpdate).then((updated) => {
                        this.props.changeGroupFunc()
                      }).catch(e => {
                        console.log(e)
                      })
                    }
                  }

                  if (dataOld && dataOld['messages'].constructor === Array && dataOld['messages'].length > 0) {
                    this.firstMessUpId = dataOld['messages'][dataOld['messages'].length - 1]['message_id']
                    if (!this.lastMessDownId) {
                      this.lastMessDownId = dataOld['messages'][0]['message_id']
                    }

                    if (dataNew && dataNew['messages'].constructor === Array && dataNew['messages'].length === 0 && this.lastMessDownId && groupInDB.unread_cnt && groupInDB.unread_cnt > 0) {
                      this.checkReadedOne(group_id, this.lastMessDownId)

                      let dataUpdate = { my_seen_mess: this.lastMessDownId, count_unread: 0 }

                      workerUnread.initUnread(group_id.toString(), '-1')

                      chatDB.groups.update(group_id.toString(), dataUpdate).then((updated) => {
                        this.props.changeGroupFunc()
                      }).catch(e => {
                        console.log(e)
                      })
                    }
                  }

                  let newMessTmp = [{ message_id: newMySeenMessId, group_id: group_id, type: -1, created_at: timeLastSeen, sender_uin: '', message: '' }]

                  let arrMessCombile = (dataNew.messages && dataNew.messages.constructor === Array && dataNew.messages.length > 0) ? [].concat(dataOld.messages, newMessTmp, dataNew.messages) : [].concat(dataOld.messages, dataNew.messages)

                  let data = {
                    last_message_id: mySeenMess,
                    messages: arrMessCombile.filter(oMess => this.checkGroupsAdminLeave(groupInDB, oMess) === true)
                  }

                  let netaGroupJoinCall = global.rxu.json(rxgetLocal('netaGroupJoinCall'), { status: false, groups: {} })
                  if (data && data.messages && data.messages.constructor === Array) {
                    data.messages.forEach(oMess => {
                      if (oMess.type === 6 && netaGroupJoinCall['groups'] && netaGroupJoinCall['groups'][oMess.group_id] && oMess['attachments'].indexOf(netaGroupJoinCall['groups'][oMess.group_id]['message_id']) !== -1) {
                        this.props.netaGroupCallRemove(oMess.group_id)
                      }
                    })

                    if (group_id === this.state.group_id) {
                      if (data && data.last_message_id && data.messages && data.messages.constructor === Array && data.messages.length > 0) {
                        const { objDate, messArrProps } = getObjMess(data)
                        let arrMess = data.messages
                        // if (arrMess[arrMess.length - 1] && arrMess[arrMess.length - 1]['message_id']) {
                        //   this.objMessOld[group_id] = arrMess[arrMess.length - 1]['message_id']
                        //   if (group.occupants_uins && group.occupants_uins.length < maxUser) {
                        //     this.checkReadedOne(group_id, this.objMessOld[this.state.group.group_id])  
                        //   }
                        // }

                        this.setState({ messages: objDate, scroll_mess: true }, () => {
                          chatDB.mess.bulkPut(messArrProps.filter(messTmp => messTmp.type !== -1))

                          let lassMessObj = data.messages[data.messages.length - 1]
                          if (lassMessObj.message_id !== last_message_id_tmp) {
                            this.checkReaded(lassMessObj.group_id, lassMessObj.message_id)
                            this.props.netaGroupsUpdateLastMess(lassMessObj.group_id, lassMessObj.message_id, lassMessObj)
                          }
                        })
                        const chatDivTmp = document.getElementById('zchat_list')
                        if (chatDivTmp) {
                          let screenHeight = Number(window.innerHeight) - 110
                          try {
                            let unreadDiv = document.querySelector('.zmessage_row_unread')
                            if (unreadDiv) {
                              chatDivTmp.scrollTo({ top: unreadDiv.offsetTop - (screenHeight / 2) })// behavior: 'smooth'
                            } else {
                              chatDivTmp.scrollTop = chatDivTmp.scrollHeight
                            }
                          } catch (e) {
                            chatDivTmp.scrollTop = chatDivTmp.scrollHeight
                          }

                          setTimeout(() => {
                            if (dataNew && dataNew['messages'].constructor === Array && dataNew['messages'].length >= 15) {
                              this.disableScrollDown = false
                            }
                          }, 1000)
                        }
                      }
                    }
                  }
                })
              })
            } catch (e2) {
            }
          }
          rxio.socket.emit('list_pinned_message', { group_id }, (data) => {
            if (group_id === this.state.group_id) {
              if (data && data.result === 0) {
                const { objDate, messArrProps } = getObjMess(data, "pinned_at")
                this.setState({ pinedMess: objDate }, () => {
                  this.props.netaMessPin(group.group_id, messArrProps)
                })
              }
            }
          })
        }

      })
    }

  }

  onClickToMess(messid) {
    let group_id = rxaget(this.state.group, 'group_id', '')
    this.flagSearchMess = true

    if (messid && messid.length > 5) {
      try {
        // Lấy dưới
        let msgOld = { group_id: group_id, last_message_id: messid, direction: 0, pindex: 0, psize: 30 }
        // Lấy trên
        let msgNew = { group_id: group_id, last_message_id: messid, direction: 1, pindex: 0, psize: 15 }

        rxio.socket.emit('list_message', msgOld, (dataOld) => {
          rxio.socket.emit('list_message', msgNew, (dataNew) => {
            this.firstMessUpId = ''
            this.lastMessDownId = ''

            if (dataNew && dataNew['messages'].constructor === Array && dataNew['messages'].length > 0) {
              this.lastMessDownId = dataNew['messages'][dataNew['messages'].length - 1]['message_id']
            }

            if (dataOld && dataOld['messages'].constructor === Array && dataOld['messages'].length > 0) {
              this.firstMessUpId = dataOld['messages'][dataOld['messages'].length - 1]['message_id']
              if (!this.lastMessDownId) {
                this.lastMessDownId = dataOld['messages'][0]['message_id']
                this.flagSearchMess = false
              }
            }

            chatDB.groups.get(group_id.toString()).then(groupInDB => {
              if (groupInDB) {
                let arrMessCombile = [].concat(dataOld.messages, dataNew.messages)
                let data = {
                  last_message_id: messid,
                  messages: arrMessCombile.filter(oMess => this.checkGroupsAdminLeave(groupInDB, oMess) === true)
                }

                if (data && data.last_message_id && data.messages && data.messages.constructor === Array && data.messages.length > 0) {
                  const sortField = 'created_at'
                  const objDate = {}
                  if (data && data.messages) {
                    const messages = data.messages.sort((a, b) => Number(a[sortField]) < Number(b[sortField]) ? -1 : 1)
                    for (const imess in messages) {
                      const omess = messages[imess]
                      if ((imess < (messages.length - 2)) && [5, 6, 7].indexOf(omess.type) === -1) {
                        const newomess = messages[Number(imess) + 1]
                        if (omess.sender_uin && newomess.sender_uin && !newomess.checked_ava) {
                          if ((omess.sender_uin === newomess.sender_uin) && ((Number(newomess[sortField]) - Number(omess[sortField])) < 60000000)) {
                            messages[Number(imess) + 1].checked_ava = true
                          }
                        }
                      }
                      if (omess && omess[sortField]) {
                        const created_at = convertSecondUnix(Number(omess[sortField]))
                        const date = timesUnixToDate(created_at, Number(omess[sortField]))
                        if (!objDate[date]) { objDate[date] = { data: [], date: date, datestr: timeConverter(date, 'dateweek') } }
                        objDate[date].data.push(omess)
                      }
                    }
                  }

                  this.setState({ messages: objDate, scroll_mess: true }, () => {
                    const chatDivTmp = document.getElementById('zchat_list')
                    const ele = this.refScroll_chat[messid]

                    ele.classList.add("hover-chat")

                    if (chatDivTmp) {
                      let screenHeight = Number(window.innerHeight)
                      try {
                        if (ele) {
                          chatDivTmp.scrollTo({ top: ele.offsetTop - (screenHeight / 2) })
                        } else {
                          chatDivTmp.scrollTop = chatDivTmp.scrollHeight
                        }
                      } catch (e) {
                        chatDivTmp.scrollTop = chatDivTmp.scrollHeight
                      }

                      setTimeout(() => {
                        ele.classList.remove("hover-chat")
                      }, 2000);

                      setTimeout(() => {
                        if (dataNew && dataNew['messages'].constructor === Array && dataNew['messages'].length >= 15) {
                          this.disableScrollDown = false
                        } else {
                          this.flagSearchMess = false
                        }
                      }, 1000)
                    }
                  })
                }
              }
            })
          })
        })
      } catch (e2) { }
    }
  }

  checkReaded(group_id, mess_id) {


  }

  changeMessage(e) {
    const group_id = this.state.group_id
    if (this.userid && group_id) {
      const me_typing = this.state.me_typing
      if (e.currentTarget.textContent) {
        if (me_typing === false) {
          rxio.sendGroupEvent(group_id, this.userid, 9)
        }
        const value = e.currentTarget.textContent
        this.setState({ mess: value, me_typing: true }, () => {
          setTimeout(() => {
            if ((value === this.state.mess) && me_typing) {
              rxio.sendGroupEvent(group_id, this.userid, 10)
              this.setState({ me_typing: false })
            }
          }, 2000)
        })
      }
    }
  }

  checkTypeDelMess() {
    let result = 0
    let messSelectedType = rxaget(this.state, 'mess_selected.type', '')
    let exclude = [1,/* 5, 6, 7*/, 10]
    if (rxaget(this.state, 'mess_selected.sender_uin', '').toString() === this.userid.toString()) {
      if (exclude.indexOf(messSelectedType) !== -1) {
        result = 1
      } else {
        if ([5, 6, 7].indexOf(messSelectedType) !== -1) {
          result = 4
        } else {
          result = 3
        }
      }
    }
    if (rxaget(this.state, 'mess_selected.status', 0) === 4) {
      result = 2
    }
    if (rxaget(this.state, 'mess_selected.deleted_uins', []).indexOf(this.userid.toString()) !== -1) {
      result = 2
    }
    if (result === 0 && rxaget(this.state, 'mess_selected.message', '') !== '') {
      result = 3
    }
    if (result === 0 && rxaget(this.state, 'mess_selected.message', '') === '') {
      if (exclude.indexOf(messSelectedType) >= 0) {
        result = 1
      } else {
        if ([5, 6, 7].indexOf(messSelectedType) !== -1) {
          result = 4
        } else {
          result = 3
        }
      }
    }

    // if (result === 3 && messSelectedType === 3) {
    //   result = 4
    // }
    return result
  }

  reloadStateWhenRepMess(data) {
    // this.setState({ type_option: 0, mess_selected: {}, mess_id: '' }, () => {
    //   // this.handleMessage(data.message, true)
    // })
  }

  resetSelectedMess() {
    this.setState({ type_option: 0, mess_selected: {}, mess_id: '' })
  }

  forwardAudio(group_id, audioAttachments) {
    const arrUsers = this.users
    const user = rxaget(this.props, 'netaauth.user', {})
    const objUser = arrUsers[user.id.toString()]

    let msg = {}
    let audioAttachmentsTmp = audioAttachments
    let arrImg = []

    audioAttachmentsTmp = audioAttachmentsTmp.replaceAll('\\"', '"')
    audioAttachmentsTmp = JSON.parse(audioAttachmentsTmp)
    arrImg[0] = audioAttachmentsTmp.audio

    if (arrImg && arrImg.constructor === Array && arrImg.length > 0) {
      msg = {
        group_id: Number(group_id),
        type: 3,
        version: 1,
        nonce: (Math.floor(Date.now()) * 1000).toString(),
        sender_name: rxaget(objUser, 'full_name', ''),
        attachments: JSON.stringify({ audio: arrImg[0] }).replace(/"/g, '\\"')
      }
    }

    if (msg && msg.group_id) {
      if (rxio.connected) {
        rxio.socket.emit('create_message', msg, (data) => {
          if (data && data.message) {
            try {
              let objMedia = {
                group_id: Number(group_id),
                media_type: msg.type,
                message_id: Number(data.message.message_id),
                msg_create_at: Number(data.message.created_at),
                url: rxaget(arrImg, '0.url', '')
              }

              this.props.netaMediaOneAdd(Number(group_id), objMedia)
            } catch (e) {
              console.log(e)
            }

            this.handleMessage(data.message, true)
          }
        })
      }

    }
  }

  chooseGroupForward(groupfw) {
    let isForwardAudio = this.state.isForwardAudio
    let mess_selected = {}
    if (isForwardAudio === true) {
      let audioAttachments = this.state.mess_selected.attachments
      this.forwardAudio(groupfw.group_id, audioAttachments)
      isForwardAudio = false
    } else {
      mess_selected = this.state.mess_selected
      mess_selected['groupfw'] = groupfw.group_id
    }

    this.setState({ mess_selected: mess_selected, popupGroup: false, type_option: 2, isForwardAudio: isForwardAudio })
  }

  onClickAva(_id) {
    this.setState({ tabmore: !this.state.tabmore, id_userclick: _id })
  }

  onClose() {
    this.setState({ tabmore: false })
  }

  showGalleryCurrentUser({ index, type }) {
    this.setState({ checkgallery: true, galleryPosition: Number(index), type: type })
  }

  changeTabActive(type) {
    const group_id = rxaget(this.state.group, 'group_id', '')
    const netaMedia = rxaget(this.props.netaMedia, 'data.' + group_id, { images: {}, videos: {}, files: {} })
    let arrData = []
    if (netaMedia && netaMedia[type]) {
      for (const key of Object.keys(netaMedia[type] || {})) {
        if (netaMedia[type][key]) { arrData.push(netaMedia[type][key]) }
      }
    }
    arrData = arrData.sort((a, b) => (a.msg_create_at > b.msg_create_at) ? -1 : ((b.msg_create_at > a.msg_create_at) ? 1 : 0))
    this.setState({ tabActive: type, arrData: arrData })
  }

  // onClickInfoUser(userInfo) {
  //   let flagStartCall = this.props.flagStartCall
  //   if(!flagStartCall){
  //     let userOwner = rxaget(this.props, 'netaauth.user', {})    
  //     let partner_id = userInfo.id
  //     let userClick_group =this.getGroupByUserId(partner_id)
  //     this.setState({ 
  //       infoUserScreen: true, 
  //       userInfo: userInfo,
  //       userClick_group:userClick_group
  //     })
  //   }
  // }

  onClickNameUser(userId) {
    // let userInfo = rxaget(this.users, userId, {})
    // let userOwner = rxaget(this.props, 'netaauth.user', {})    
    // let partner_id = userInfo.id
    // let userClick_group =this.getGroupByUserId(partner_id)
    // this.setState({ 
    //   infoUserScreen: true, 
    //   userInfo: userInfo,
    //   userClick_group:userClick_group
    // })
  }

  closePopupInfoUser() {
    this.setState({
      infoUserScreen: false,
      infoUserId: 0
    })
  }

  getStringsImages(arrData) {
    let galleryImages = ''
    arrData.forEach(element => {
      galleryImages += element.url.replace(/\s/g, '') + ','
    })
    return (
      galleryImages
    )
  }

  scrollDownChatList(e) {
    let group_id = this.state.group_id
    this.disableScrollDown = true

    const msg = {
      group_id: group_id,
      pindex: 0,
      psize: 30
    }

    let objDate = {}

    rxio.socket.emit('list_message', msg, (data) => {
      if (data && data.messages && data.messages.constructor === Array) {

        let messages = data.messages.sort((a, b) => Number(a.created_at) > Number(b.created_at) ? 1 : -1)

        for (const imess in messages) {
          const omess = messages[imess]
          if ((imess < (messages.length - 2)) && [5, 6, 7].indexOf(omess.type) === -1) {
            const newomess = messages[Number(imess) + 1]
            if (omess.sender_uin && newomess.sender_uin && !newomess.checked_ava) {
              if ((omess.sender_uin === newomess.sender_uin) && ((Number(newomess.created_at) - Number(omess.created_at)) < 60000000)) {
                messages[Number(imess) + 1].checked_ava = true
              }
            }
          }
          if (omess && omess.created_at) {
            const created_at = convertSecondUnix(Number(omess.created_at))
            const date = timesUnixToDate(created_at, Number(omess.created_at))
            if (!objDate[date]) { objDate[date] = { data: [], date: date, datestr: timeConverter(date, 'dateweek') } }
            const findMess = objDate[date].data.find(o => o.message_id === omess.message_id)
            if (!findMess) {
              objDate[date].data.push(omess)
            }
          }
        }

        if (messages.length > 0) {
          this.firstMessUpId = messages[0]['message_id']
          this.lastMessDownId = messages[messages.length - 1]['message_id']
        }
        this.scrollBlock = true
        this.setState({ messages: objDate }, () => {
          let screenHeight = Number(window.innerHeight) - 110
          const chatDivTmp = document.getElementById('zchat_list')
          if (chatDivTmp) {
            chatDivTmp.scrollTop = chatDivTmp.scrollHeight + screenHeight
          }

          chatDB.groups.get({ group_id: group_id.toString() }).then(groupInDB => {
            if (groupInDB) {
              let dataUpdate = { my_seen_mess: this.lastMessDownId, count_unread: 0 }

              this.checkReadedOne(group_id, this.lastMessDownId)

              workerUnread.initUnread(group_id.toString(), '-1')

              chatDB.groups.update(group_id.toString(), dataUpdate).then((updated) => {
                this.props.changeGroupFunc()
                try {
                  setTimeout(() => {
                    this.scrollBlock = false
                  }, 1000)
                } catch (e) { }
              }).catch(e => {
                console.log(e)
              })
            }
          })
        })
      }
    })
  }

  clickInfoUser(userid) {
    console.log(userid)
    if (userid) {
      this.setState({
        infoUserScreen: true,
        infoUserId: Number(userid)
      })
    }

    // console.log(useridtmp)
    // console.log(userOwnerid)
    // console.log(groupid)
    // try {
    //   let finduser = await chatDB.users.get(Number(userid))
    //   console.log(finduser)
    //   if(useridtmp !== userOwnerid && finduser){
    //     let user = finduser
    //     let partner_id = user.id
    //     let userOwner = worker.users[userOwnerid]
    //     let userClick_group =window[groupid]


    //     console.log(userClick_group)

    //     window.vmChat.setState({
    //       infoUserScreen: true,
    //       userInfo:user,
    //       avatarClick_user: user,
    //       currentSender_uin: useridtmp,
    //       userClick_group:userClick_group,
    //       tagIsClick: true
    //     })
    //     let infoUserScreen = window.vmChat.state.infoUserScreen
    //   }
    // } catch(e) {
    //   console.log(e)
    // }
  }


  parseMessage(objmsg, type) {
    // let t0 = performance.now();
    let message = ''
    let attachments = {}
    const userid = rxaget(this.props, 'netaauth.user.id', '').toString()
    if (objmsg) {
      if (!isNaN(objmsg.type)) {
        try {
          attachments = JSON.parse(rxaget(objmsg, 'attachments', '').replace(/[\t\r\n]/g, '').replace(/\\/g, '\\\\'))
        } catch (e) {
          try {
            attachments = JSON.parse(rxaget(objmsg, 'attachments', '').replace(/[\t\r\n]/g, ''))
          } catch (e2) {
            if (typeof (rxaget(objmsg, 'attachments', '')) === 'object') {
              attachments = rxaget(objmsg, 'attachments', '')
            }
          }
        }
        if (objmsg.status !== 4) {
          if (objmsg.deleted_uins && objmsg.deleted_uins.constructor === Array && objmsg.deleted_uins.length > 0 && objmsg.deleted_uins.indexOf(userid) !== -1) {
            message = getDeleteMessStr(objmsg, this.users, this.userid)
          } else {
            let mess = ''
            switch (objmsg.type) {
              case 1:
                let call_name = ''
                let icon_call_name = ''
                if (attachments.media_type === 1) {
                  call_name = translate('Voice call')
                  icon_call_name = 'icon-phone'
                } else if (attachments.media_type === 2) {
                  call_name = translate('Video call')
                  icon_call_name = 'icon-camrecorder'
                }
                let iconcall = ''
                let stylecall = ''
                if (rxaget(attachments, 'caller_uin', '') === this.userid.toString()) {
                  iconcall = 'icon-call-out'
                  if (zget(this.props, 'themeValue') === 'blueColor') {
                    stylecall = '#fdf2ea'
                  } else {
                    if (rxconfig.theme === 'galo') {
                      stylecall = '#d4f5f1'
                    } else if (rxconfig.theme === 'default') {
                      stylecall = '#e5efff'
                    }
                  }
                } else {
                  iconcall = 'icon-call-in'
                  if (zget(this.props, 'themeValue') === 'blueColor') {
                    stylecall = '#fdf2ea'
                  } else {
                    if (rxconfig.theme === 'galo') {
                      stylecall = '#d4f5f1'
                    } else if (rxconfig.theme === 'default') {
                      stylecall = '#e5efff'
                    }
                  }
                }
                message = `<div class='zchat-callmess' style='background: ${stylecall};'>
                  <div class='zchat-callname'>${call_name}</div>`
                if (attachments.accepted_at === '0') {
                  message += `<div class='zchat-calltime' style='color:#d5192d;'><i class='${iconcall}'></i>${translate('Canceled')}</div>`
                } else {
                  const time = Number(rxaget(attachments, 'stopped_at', 0)) - Number(rxaget(attachments, 'accepted_at', 0))
                  message += `<div class='zchat-calltime'><i class='${iconcall}' style='color:#2fb13e;'></i>${secondToTime(time)}</div>`
                }
                message += `<span class='zchat-callicon'><i class='${icon_call_name}'></i></span></div>`
                if (type === 'desc') {
                  mess = translate(' finished')
                  message = call_name + mess
                }
                break
              case 2:
                try {
                  if (attachments && attachments.images && attachments.images.constructor === Array && attachments.images.length > 0) {
                    let arrurlimgs = rxaget(attachments, 'images', []).map(o => o.url)
                    let strurlimgs = (arrurlimgs && arrurlimgs.constructor === Array && arrurlimgs.length > 0) ? arrurlimgs.join(',') : ''
                    message = `<div> <div></div> <div class="img-message-row" id=${objmsg.message_id}>`
                    let indeximg = 0
                    let imgHeight = 0
                    for (const img of attachments.images) {
                      if (!attachments.loading) {
                        if (img.height >= 360 && img.width >= 240) {
                          switch (img.height / img.width) {
                            case 1.5:
                              imgHeight += 360
                              break;
                            case 1:
                              imgHeight += 240
                              break;
                            default:
                              if (img.height / img.width > 1.5) {
                                imgHeight += 360
                              }
                              if (img.height / img.width < 1.5) {
                                let imgHeightTmp = 240 * (img.height / img.width)
                                if (imgHeightTmp >= 360) {
                                  imgHeight += 360
                                } else {
                                  imgHeight += imgHeightTmp
                                }
                              }
                          }
                        } else {
                          if (img.height >= 360) {
                            imgHeight += 360
                          } else {
                            if (img.width >= 240) {
                              imgHeight += 240 * (img.height / img.width)
                            } else {
                              imgHeight += img.height
                            }

                          }

                        }
                      }
                      if (attachments.loading)
                        message += `<img class='zchat-mess-cancel-btn' alt='icon-cancel-btn' onclick=window.cancleUpload('${objmsg.message_id}','${img.url}') src='./images/default/icons/icon-cancel-btn.svg'/><div class="loading"></div>`

                      let strImgForward = img.url + '|' + (img.width || 0) + '|' + (img.height || 0)
                      message += `<img src='${((!attachments.loading ? global.rxu.config.get_static : "") + img.url)}' alt='' class='${!objmsg.message ? "img-message" : "img-message message-offborder"}' onclick=window.showGallery('${strurlimgs}','${indeximg}') onmousedown="window.getGallery('${strImgForward}','${indeximg}')" />`
                      indeximg += 1
                    }
                    message += '</div></div>'

                    if (objmsg.message) {
                      let messagetmp = this.convertUrlMess(objmsg, type)
                      if (this.userid.toString() === objmsg.sender_uin.toString()) {
                        message += `<span class='img-message-text'>${messagetmp}</span>`
                      } else {
                        message += `<span class='img-message-text img-message-text-another'>${messagetmp}</span>`
                      }

                    }

                    if (!(type === 'lastpin' || attachments.loading))
                      message = message.replace('class="img-message-row"', 'class="img-message-row"style="height:' + imgHeight + 'px;"')
                    if (type === 'desc') {
                      message = translate('Image')
                    }
                  }
                } catch (e) {
                  console.log(e)
                }
                break
              case 3:
                let audio = (attachments && attachments.audio) || objmsg.audio
                const url = rxaget(audio, 'url', '')
                const src = global.rxu.config.get_static + url
                message = `<div class='zchat-audiomess'>`
                let id = objmsg.message_id
                if (objmsg.rpId) id += objmsg.rpId
                if (type === 'pin_model') {
                  id = 'pin_model' + id
                }
                message += `
                  <div class='zchat-audioicon filter_img_class' onclick=window.playAudio('icon-audio-${id}')>
                    <img id='icon-audio-${id}'  src='./images/default/static/icon-media-play.svg'/>
                  </div>`

                message +=
                  `
                  <div class='zchat-audiobar'>
                    <div class='zchat-audioprocess' id='process-audio-${id}'>
                    </div>
                  </div>
                  <div class='zchat-audiotime'>
                    ${secondToTime(rxaget(audio, 'duration', 0))}
                  </div>
                `
                message += `
                  <audio id='${'audio-' + id}' >
                    <source id='${'audio' + url}' src='${src}' type='audio/mpeg'/>
                  </audio>
                `
                message += `</div>`
                if (type === 'desc') {
                  message = 'Audio'
                }
                break
              case 4:
                try {
                  if (attachments && attachments.video && attachments.video.url) {
                    const url = attachments.video.url
                    let src
                    // let videoControls = "controls='controls'"
                    let videoControls = 'controls'
                    let videoObj = attachments.video
                    let videoHeight = 241 * (videoObj.height / videoObj.width)

                    message = '<div class="img-message-row">'
                    if (attachments.loading) {
                      src = url
                      message += `<img class='zchat-mess-cancel-btn' alt='icon-cancel-btn' onclick=window.cancleUpload('${objmsg.message_id}','${attachments.video.url}') src='./images/default/icons/icon-cancel-btn.svg'/> <div class="loading"></div>`
                      videoControls = ''
                    } else {
                      src = global.rxu.config.get_static + url
                    }
                    message += `
                        <video class='${!objmsg.message ? "zchat-mess-video" : "zchat-mess-video message-offborder"}' id='${'video' + objmsg.message_id}' height='${videoHeight}' width='320' ${videoControls} preload='metadata'>
                          <source id='${'video' + url}' src='${src}#t=0.1' />
                          Your browser does not support HTML5 video.
                        </video>
                      `
                    if (objmsg.message) {
                      message += `<span class='video-message-text'>${objmsg.message}</span>`
                    }
                    message += '</div>'
                    if (type === 'desc') {
                      message = 'Video'
                    }
                  }
                } catch (e) {
                  console.log(e)
                }
                break
              case 5:
                if (objmsg.group_type === 4) {
                  mess = translate(' created a channel')
                  message = checkNameUser(rxaget(this.users, objmsg.sender_uin.toString(), {})) + mess
                } else if (objmsg.group_type !== 3) {
                  mess = translate(' created a group')
                  message = checkNameUser(rxaget(this.users, objmsg.sender_uin.toString(), {})) + mess
                } else {
                  try {
                    let receiver_uin = objmsg.recipient_uins.filter(uin => uin.toString() != this.userid.toString())
                    if (receiver_uin && receiver_uin.length > 0) {
                      mess = translate('Start chat with ')
                      message = mess + checkNameUser(rxaget(this.users, receiver_uin[0].toString(), {}))
                    }
                  } catch (e3) { }
                }

                break
              case 6:
                const userins = []
                try {
                  if (attachments && attachments.added_uins && attachments.added_uins.constructor === Array && attachments.added_uins.length > 0) {
                    for (const uid of attachments.added_uins) {
                      const uname = checkNameUser(rxaget(this.users, uid.toString(), {}))
                      if (uname) {
                        userins.push(uname)
                      }
                    }
                  }
                  else if (attachments.removed_uins && attachments.removed_uins.constructor === Array && attachments.removed_uins.length > 0) {
                    let rmMem = []
                    for (const uid of attachments.removed_uins) {
                      const uname = checkNameUser(rxaget(this.users, uid.toString(), {}))
                      if (uname) {
                        rmMem.push(uname)
                      }
                    }
                    if (rmMem.length > 0) {
                      mess = translate(' removed ')
                      message = checkNameUser(rxaget(this.users, objmsg.sender_uin.toString(), {})) + mess + rmMem.join(', ')
                    }
                  }
                  else if (attachments.pin_message) {
                    if (attachments.pin_message && attachments.pin_message.type !== 17) {
                      mess = attachments.pin_message.type === -1 ? attachments.pin_message.content :
                        (checkNameUser(rxaget(this.users, objmsg.sender_uin.toString(), {})) + (attachments.pin_message.content ? (translate(' pinned') + ": " + attachments.pin_message.content) :
                          translate(' pinned one message')))
                      message = mess
                    } else {
                      mess = (checkNameUser(rxaget(this.users, objmsg.sender_uin.toString(), {})) + translate(' just pinned the poll'))
                      message = mess
                    }
                  }
                  else if (attachments && attachments.updated_group_avatar) {
                    message = (checkNameUser(rxaget(this.users, objmsg.sender_uin.toString(), {}))) + translate(' update avatar')
                  }
                  else if (attachments && attachments.updated_group_name) {
                    message = (checkNameUser(rxaget(this.users, objmsg.sender_uin.toString(), {}))) + translate(' update group name')
                  }
                  else if (attachments && attachments.type === 'update_group' && (attachments.owner_uin || attachments.admin_uins)) {
                    message = (checkNameUser(rxaget(this.users, objmsg.sender_uin.toString(), {}))) + translate(' change group admin to: ')
                      + (checkNameUser(rxaget(this.users, (attachments.owner_uin || attachments.admin_uins[0]).toString(), {})))
                  } else if (attachments && attachments.group_id && attachments.push_all && attachments.push_all.constructor === Array && attachments.push_all.length > 0) {
                    try {
                      const arrUserNameAdd = []
                      for (const uid of attachments.push_all) {
                        const unameNew = checkNameUser(rxaget(this.users, uid.toString(), {}))
                        if (unameNew) {
                          arrUserNameAdd.push(unameNew)
                        }
                      }
                      if (arrUserNameAdd.length > 0) {
                        message = arrUserNameAdd.join(', ') + translate(' joined group with link')
                      }
                    } catch (e1) { }
                  }
                } catch (e) {
                  console.log(e)
                }
                if (userins.length > 0) {
                  mess = translate(' added ')
                  message = checkNameUser(rxaget(this.users, objmsg.sender_uin.toString(), {})) + mess + userins.join(', ')
                }
                break
              case 7:
                mess = translate(' has left the group')
                message = checkNameUser(rxaget(this.users, objmsg.sender_uin.toString(), {})) + mess
                break
              case 8:
                message = '<div class=\'row-reply\'>'
                message += `<div class='sender-reply'> <img class='filter_img_class' alt='icon-reply' src='${changeColorSVG('./images/default/icons/reply-icon.svg')}'> ${translate('Answer for')} ${checkNameUser(rxaget(this.users, attachments.sender_uin, {})) || ''} </div>`


                if (attachments.type === 8 || attachments.type === 9) {
                  attachments.type = 0
                }
                try {
                  attachments.rpId = objmsg.message_id
                } catch (e5) { }
                const attachments_tmp = this.parseMessage(attachments)
                if (attachments_tmp !== '') {

                  let message_reply_content_class = ''
                  let file_reply_content_class = ''
                  if (attachments_tmp.indexOf('img-message-row') !== -1 || attachments_tmp.indexOf('zchat-filemess') !== -1 || attachments_tmp.indexOf('zchat-audiomess') !== -1) {
                    file_reply_content_class = ' file-reply_content'

                  }
                  if (checkIsOwner(objmsg, this.userid)) {
                    message_reply_content_class = 'message-reply_content_right' + file_reply_content_class
                  } else {
                    message_reply_content_class = 'message-reply_content' + file_reply_content_class
                  }

                  message += `
                      <div class='clearfix message-reply'>
                        <div></div>
                        <div class='${message_reply_content_class}''>
                          ${attachments_tmp}
                        </div>
                      </div>`
                } else {
                  if (checkIsOwner(objmsg, this.userid)) {
                    message += `
                    <div class='message-reply'>
                      <div></div>
                      <div class='message-reply_content_right' >
                        &nbsp;
                      </div>
                    </div>`
                  }
                  else {
                    message += `
                    <div class='message-reply'>
                      <div></div>
                      <div class='message-reply_content'>
                        &nbsp;
                      </div>
                    </div>`
                  }
                }

                let messagetmpReply = this.convertUrlMess(objmsg, type)
                message += '</div>'
                if (this.userid.toString() === objmsg.sender_uin.toString()) {

                  message += '<div class=\'zmessage-reply-anwser my_message\'>' + /*objmsg.message*/messagetmpReply + '<div class=\'zmessage_time\'> ' + timeConverter(objmsg.created_at, 'minute') + ' </div></div>' || ''
                } else {
                  if (objmsg.message.length === 0) {
                    message += '<div class=\'zmessage-reply-anwser another_message\'><div class=\'another_message_box\'>&#160<div class=\'zmessage_time\'> ' + timeConverter(objmsg.created_at, 'minute') + ' </div></div></div>' || ''
                  }
                  else {
                    message += '<div class=\'zmessage-reply-anwser another_message\'><div class=\'another_message_box\'>' + this.convertTagName(messagetmpReply) + '<div class=\'zmessage_time\'> ' + timeConverter(objmsg.created_at, 'minute') + ' </div> </div></div>' || ''
                  }

                }
                if (type === 'desc') {
                  message = objmsg.message
                }
                break
              case 9:

                let sender_name
                let sender_name_mess = translate('You')
                sender_name = checkIsOwner(attachments, this.userid) ? sender_name_mess : checkNameUser(rxaget(this.users, objmsg.sender_uin, {}))
                message = '<div class=\'row-reply\'>'
                message += `<div class='sender-reply '> <img class='filter_img_class' alt='icon-reply' src='${changeColorSVG('./images/default/icons/forward-icon.svg')}'/> ${sender_name || ''} ${translate('forwarded a message')} </div>`

                attachments.rpId = objmsg.message_id
                if (attachments.type === 9 || attachments.type === 8) {
                  attachments.type = 0
                }
                const attachments_forward = this.parseMessage(attachments)
                if (attachments_forward !== '') {

                  let message_reply_content_class = ''
                  let file_reply_content_class = ''
                  if (attachments_forward.indexOf('img-message-row') !== -1 || attachments_forward.indexOf('zchat-filemess') !== -1 || attachments_forward.indexOf('zchat-audiomess') !== -1) {
                    file_reply_content_class = ' file-reply_content'

                  }
                  if (checkIsOwner(objmsg, this.userid)) {
                    message_reply_content_class = 'message-reply_content_right' + file_reply_content_class
                  } else {
                    message_reply_content_class = 'message-reply_content' + file_reply_content_class
                  }

                  message += `
                      <div class='clearfix message-reply'>
                        <div></div>
                        <div class='${message_reply_content_class}''>
                          ${attachments_forward}
                        </div>
                      </div>`
                }
                let messagetmpForward = this.convertUrlMess(objmsg, type)
                message += '</div>'
                if (this.userid.toString() === objmsg.sender_uin.toString()) {
                  if (objmsg.message) {
                    message += '<div class=\'zmessage-reply-anwser my_message\'>' + messagetmpForward + '<div class=\'zmessage_time\'> ' + timeConverter(objmsg.created_at, 'minute') + ' </div></div>' || ''
                  }
                } else {
                  if (objmsg.message.length === 0) {
                    // message += '<div class=\'zmessage-reply-anwser another_message\'><div class=\'another_message_box\'>&nbsp;</div></div>' || ''
                  } else {
                    message += '<div class=\'zmessage-reply-anwser another_message\'><div class=\'another_message_box\'>' + messagetmpForward + '<div class=\'zmessage_time\'> ' + timeConverter(objmsg.created_at, 'minute') + ' </div></div></div>' || ''
                  }


                }
                if (type === 'desc') {
                  message = objmsg.message
                }
                break
              case 10:
                try {
                  if (attachments && attachments.sticker) {

                    const namesticker = attachments.sticker || ''
                    if (namesticker && typeof (namesticker) === 'string') {
                      let indexPath = namesticker.indexOf('_')
                      let stickerStr = indexPath < 0 ? '' : namesticker.slice(0, indexPath)
                      let imgsticker = indexPath < 0 ? '' : namesticker.slice(indexPath + 1)
                      if (indexPath !== -1) {
                        if (this.checkSticker(stickerStr, imgsticker)) {
                          if (getExtension(attachments.sticker) === 'json') {
                            message = `<lottie-player autoplay loop mode='normal' style='width: 100px; height:100px' src='${this.state.pathImg}/${stickerStr}/${imgsticker}'></lottie-player>`
                          } else {
                            message = `<img src='${this.state.pathImg}/${stickerStr}/${imgsticker}' alt='sticker' class='img-sticker' onerror='this.onerror=null;this.src="./images/tabs/default.jpg";'/>`
                          }
                        } else {
                          message = `<img src='./images/tabs/default.jpg' alt='sticker' class='img-sticker' />`
                        }

                      }

                      break
                    }

                  }
                } catch (e) {
                  console.log(e)
                }
                if (type === 'desc') {
                  message = 'Sticker'
                }
                break
              case 12:
                let file = (attachments && attachments.file) || objmsg.file
                if (file) {
                  let file_name = rxaget(file, 'file_name', '').toString()
                  file_name = file_name.replace(/[\s]/g, '-')
                  let fileNameExt = file_name + '.' + rxaget(file, 'file_extension', '')

                  if (attachments.loading) {
                    message = `<div class="img-message-row" id=${objmsg.message_id}>`
                    message += `<img class='zchat-mess-cancel-btn' alt='icon-cancel-btn' onclick=window.cancleUpload('${objmsg.message_id}','${file.url}') src='./images/default/icons/icon-cancel-btn.svg'/><div class="loading"></div>`
                    message += `<div class='${!objmsg.message ? "zchat-filemess" : "zchat-filemess message-offborder"}'>
                    <div class='zchat-filename'>${rxaget(file, 'file_name', '')}</div>`
                    message += `<div class='zchat-calltime' style='color:#a6a6a7;'>${formatBytes(rxaget(file, 'size', 0))}</div>`
                    message += `<span class='zchat-docicon'><i class='icon-doc'></i></span></div>`
                    message += '</div>'
                  } else {
                    message = `<div class='${!objmsg.message ? "zchat-filemess" : "zchat-filemess message-offborder"}'>
                    <div class='zchat-filename'>${rxaget(file, 'file_name', '')}.${rxaget(file, 'file_extension', '')}</div>`
                    message += `<div class='zchat-calltime' style='color:#a6a6a7;'>${formatBytes(rxaget(file, 'size', 0))}</div>`
                    message += `<span class='zchat-docicon' onclick=window.downloadFile('${rxaget(file, 'url', '').toString()}','${fileNameExt}')><i class='icon-doc'></i></span></div>`
                  }

                  if (objmsg.message) {
                    let messagetmp = this.convertUrlMess(objmsg, type)
                    if (this.userid.toString() === objmsg.sender_uin.toString()) {
                      message += `<span class='file-message-text'>${messagetmp}</span>`
                    } else {
                      message += `<span class='file-message-text img-message-text-another'>${messagetmp}</span>`
                    }
                  }

                  if (type === 'desc') {
                    message = translate('File')
                  }
                }
                break
              case 14:
                try {
                  if (attachments && attachments.location) {
                    message = `<div> <div></div> <div class="img-message-row" id=${objmsg.message_id}>`
                    let imgHeight = 240

                    if (attachments.location && attachments.location.image_url) {
                      let linkMap = ''
                      if (rxaget(attachments, 'location.lat', 0) && rxaget(attachments, 'location.long', 0)) {
                        linkMap = `https://www.google.com/maps/search/?api=1&query=${rxaget(attachments, 'location.lat', 0)},${rxaget(attachments, 'location.long', 0)}`
                      }
                      message += `<img src='${(global.rxu.config.get_static + attachments.location.image_url)}' alt='' class='img-message' onclick=window.openExternalLink('${linkMap}') />`
                    }


                    message += '</div></div>'
                    if (!(type === 'lastpin' || attachments.loading))
                      message = message.replace('class="img-message-row"', 'class="img-message-row" style="height:' + imgHeight + 'px;"')
                    if (type === 'desc') {
                      message = translate('Position')
                    }
                  }
                } catch (e) {
                  console.log(e)
                }
                break
              case 15:
                try {
                  if (attachments) {
                    message = `<div> <div></div> <div class="img-message-row" id=${objmsg.message_id}>`
                    let imgHeight = 240

                    if (attachments.image_url) {
                      let linkMap = ''
                      if (rxaget(attachments, 'latitude', 0) && rxaget(attachments, 'longitude', 0)) {
                        linkMap = `https://www.google.com/maps/search/?api=1&query=${rxaget(attachments, 'latitude', 0)},${rxaget(attachments, 'longitude', 0)}`
                      }

                      message += `<img src='${(global.rxu.config.get_static + attachments.image_url)}' alt='' class='img-message' onclick=window.openExternalLink('${linkMap}') />`
                    }

                    let endTime = (attachments.ended_at) ? Number(attachments.ended_at) : 0
                    let currentTime = Math.floor(Date.now() / 1000)
                    let flagTime = endTime - currentTime

                    if (flagTime > 0) {
                      let strTime = ''
                      let percentTime = 0

                      if (flagTime < 60) {
                        strTime = flagTime + 's'
                      } else if (flagTime >= 60 && flagTime < 3600) {
                        strTime = Math.floor(flagTime / 60) + 'm'
                      } else if (flagTime > 3600) {
                        strTime = Math.floor(flagTime / 3600) + 'h'
                      }

                      if (attachments.duration && !isNaN(attachments.duration) && Number(attachments.duration) > flagTime) {
                        percentTime = parseFloat((100 - ((flagTime / Number(attachments.duration)) * 100)).toFixed(2))
                      }
                      let degCircle = Math.floor((360 / 100) * percentTime)
                      let rightTime = (percentTime < 50) ? degCircle : 180
                      let clipStr = (percentTime > 50) ? 'clip: rect(auto, auto, auto, auto);' : ''
                      let leftTime = (percentTime > 50) ? 'transform:rotate(' + degCircle + 'deg);' : 'display:none'

                      message += `<div class='position-message-row'>
                        <span class='position-record-point'></span>
                        <div class='position-desc'>
                          <div>Đang chia sẻ hành trình</div>
                          <div class='zlocation_desc'>Cập nhật liên tục</div>
                        </div>
                        <div class='position-timer-process'>
                          <div class='position-pie-wrapper'>
                            <span class='position-label'>${strTime}</span>
                            <div class='position-pie' style='${clipStr}'>
                              <div class='position-half-circle' style='${leftTime}'></div>
                              <div class='position-half-circle' style='transform:rotate(${rightTime}deg);'></div>
                            </div>
                            <div class='position-shadow'></div>
                          </div>
                        </div>
                      </div>`
                    } else {
                      message += `<div class='position-message-row'>
                        <div>Hành trình trực tiếp</div>
                        <div class='zlocation_desc'>Đã kết thúc</div>
                      </div>`
                    }

                    message += '</div></div>'
                    if (!(type === 'lastpin' || attachments.loading))
                      message = message.replace('class="img-message-row"', 'class="img-message-row" style="height:' + imgHeight + 'px;"')
                    if (type === 'desc') {
                      message = translate('Current Position')
                    }
                  }
                } catch (e) {
                  console.log(e)
                }
                break

              case 16:
                let stylecallgroup = ''
                if (zget(this.props, 'themeValue') === 'blueColor') {
                  stylecallgroup = '#fdf2ea'
                } else {
                  if (rxconfig.theme === 'galo') {
                    stylecallgroup = '#d4f5f1'
                  } else if (rxconfig.theme === 'default') {
                    stylecallgroup = '#e5efff'
                  }
                }

                let objCallStr = JSON.stringify({
                  group_id: objmsg.group_id,
                  message_id: objmsg.message_id
                })

                message = `<div class='zchat-callmess' style='background: ${stylecallgroup};'>
                  <div class='zchat-callname'>${translate('Call Group')}</div>`

                const time = Number(rxaget(attachments, 'stopped_at', 0)) - Number(rxaget(attachments, 'created_at', 0))
                message += `<div class='zchat-calltime'><i class='icon-call-in' style='color:#2fb13e;'></i>${secondToTime(time)}</div>`

                message += `<span class='zchat-callicon' onclick=window.onClickGroupCall(${objCallStr})><i class='icon-phone'></i></span></div>`
                if (type === 'desc') {
                  mess = translate(' finished')
                  message = call_name + mess
                }
                break

              default:
                let messagetmp = objmsg.message || ''
                if (messagetmp && messagetmp.length < 50) {
                  let resMess = messagetmp.match(/(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g)
                  if (resMess && resMess.constructor === Array && resMess.length > 0) {
                    let uniemoji = [...new Set(resMess)]
                    for (let emoji of uniemoji) {
                      let regEmoji = new RegExp(emoji, 'g')
                      messagetmp = messagetmp.replace(regEmoji, '<span>' + emoji + '</span>')
                    }
                  }
                }
                messagetmp = this.convertUrlMess(objmsg, type)

                // if (messagetmp.indexOf('http') !== -1 && type !== 'pin_model') {
                //   try {
                //     let urls = messagetmp.match(/(\b(https?|http|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/ig)
                //     if (urls && urls.constructor && urls.length > 0) {
                //       let objReview = {
                //         uid: objmsg.group_id + '-' + objmsg.message_id,
                //         url: urls[0]
                //       }
                //       let objLink = rxaget(this.props, 'netaLink.data.' + objReview.uid, {})
                //       if (objLink && !objLink.uid) {
                //         if (window && window.ipcRenderer && !this.checkLink[objReview.uid]) {
                //           window.ipcRenderer.send('linkpreview', objReview)
                //         }
                //         this.checkLink[objReview.uid] = true

                //         // 
                //         for (let link of urls) {
                //           messagetmp = messagetmp.replace(link, `<span class='highlight_link' onclick=window.openExternalLink('${link}')>${link}</span>`)
                //         }

                //       } else {
                //         if (objLink.title !== '') {
                //           const strmessagetmp = messagetmp
                //           const strtitle = subString(rxaget(objLink, 'title', ''), 80)
                //           const strdesc = subString(rxaget(objLink, 'description', ''), 100)

                //           messagetmp = `<div class='media_review'>
                //             <div>${strmessagetmp}</div>
                //             <div class='media_review_box' onclick=window.openExternalLink('${rxaget(objLink, 'url', '')}')>
                //               <div class='review_box-title'>${strtitle}</div>
                //               <div class='review_box-image'><img src='${(objLink.img) ? objLink.img : './images/tabs/default.jpg' }' alt='' class='review_box-img' /></div>
                //               <div class='review_box-desc'>${strdesc}</div>
                //             </div>
                //           </div>`
                //         }
                //       }

                //     }
                //   } catch (eurl) {
                //     console.log(eurl)
                //   }
                // }

                message = `<div class='zchat-textmess'>${messagetmp}</div>`

                break
            }
          }
        } else {

          message = getDeleteMessStr(objmsg, this.users, this.userid)
        }
      } else {
        if (objmsg.status !== 4) {
          if (objmsg.deleted_uins && objmsg.deleted_uins.constructor === Array && objmsg.deleted_uins.length > 0 && objmsg.deleted_uins.indexOf(userid) !== -1) {
            message = getDeleteMessStr(objmsg, this.users, this.userid)
          } else {
            message = objmsg.message || ''
          }
        } else {
          message = getDeleteMessStr(objmsg, this.users, this.userid)
        }
      }
      if (message.indexOf('@') !== -1) {
        let userstag = message.match(/(@\d+\b)/ig)
        if (userstag && userstag.constructor === Array && userstag.length > 0) {
          userstag.forEach(o => {
            let useridtmp = o.replace('@', '') || ''
            if (this.users[useridtmp]) {
              window[useridtmp] = this.users[useridtmp]
              window[this.userid] = rxaget(this.props, 'netaauth.user', {})
              let useridtmp_group = this.getGroupByUserId(useridtmp)
              let partnerIdTmp = ''
              if (useridtmp_group && useridtmp_group.group_id) {
                partnerIdTmp = useridtmp_group.group_id
                window[partnerIdTmp] = useridtmp_group
              }

              message = objmsg.type === 6 ? message.replace(o, checkNameUser(rxaget(this.users, useridtmp, {})))
                : message.replace(o, `<b onClick="window.showInfoUser('${useridtmp}')">${checkNameUser(rxaget(this.users, useridtmp, {}))}</b>`)
            }
          })
        }
      }

      if (message.indexOf('[') !== -1) {
        message = message.replace(/\[b\]([\s\S]*?)\[\/b\]/g, '<span class="bbcode-bold">$1</span>')
        message = message.replace(/\[i\]([\s\S]*?)\[\/i\]/g, '<i>$1</i>')
        message = message.replace(/\[u\]([\s\S]*?)\[\/u\]/g, '<u>$1</u>')
      }
      // let t1 = performance.now();
      // console.log("chat mess parsemess" + '(t1 - t0)' + " milliseconds.")
      return message
    } else {
      return ''
    }
  }

  convertTagName(message) {
    let userstag = message.match(/(@\d+\b)/ig)
    if (userstag && userstag.constructor === Array && userstag.length > 0) {
      userstag.forEach(o => {
        let useridtmp = o.replace('@', '') || ''
        if (this.users[useridtmp]) {
          let usernametmp = this.checkNameUser(this.users[useridtmp])

          message = message.replace(o, '<b onClick="ClickInfoUser(' + useridtmp + ',' + this.userid + ',' + '' + ')">' + usernametmp + '</b>')
        }

      })
    }
    return message
  }

  convertUrlMess(objmsg, type) {
    if (objmsg.message) {
      let messagetmp = objmsg.message || ''
      if (messagetmp.indexOf('http') !== -1) {
        try {
          let urls = messagetmp.match(/(\b(https?|http|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/ig)
          if (urls && urls.constructor && urls.length > 0) {
            let objReview = {
              uid: objmsg.group_id + '-' + objmsg.message_id,
              url: urls[0]
            }
            let objLink = rxaget(this.props, 'netaLink.data.' + objReview.uid, {})
            if (objLink && !objLink.uid) {
              if (window && window.ipcRenderer && !this.checkLink[objReview.uid]) {
                window.ipcRenderer.send('linkpreview', objReview)
              }
              this.checkLink[objReview.uid] = true

              for (let link of [...new Set(urls)]) {
                messagetmp = messagetmp.replace(link, `<span class='highlight_link' onclick=window.openExternalLink('${link}')>${link}</span>`)
              }

            } else {
              if (objLink.title !== '') {
                for (let link of urls) {
                  messagetmp = messagetmp.replace(link, `<span class='highlight_link' onclick=window.openExternalLink('${link}')>${link}</span>`)
                }
                const strmessagetmp = messagetmp
                const strtitle = subString(rxaget(objLink, 'title', ''), 80)
                const strdesc = subString(rxaget(objLink, 'description', ''), 100)

                messagetmp = `<div class='media_review'>
                  <div>${strmessagetmp}</div>
                  <div class='media_review_box' onclick=window.openExternalLink('${rxaget(objLink, 'url', '')}')>
                    <div class='review_box-title'>${strtitle}</div>
                    <div class='review_box-image'><img src='${(objLink.img) ? objLink.img : './images/tabs/default.jpg'}' alt='' class='review_box-img' /></div>
                    <div class='review_box-desc'>${strdesc}</div>
                  </div>
                </div>`
              }
            }

          }
        } catch (eurl) {
        }
      }
      return messagetmp

    }
  }

  chooseEmoji = (emoji) => {
    const { selectedMessId, messages } = this.state;
    // console.log('reactions:', reactions)
    Object.keys(messages).forEach(odate => {
      messages[odate].data.forEach((msg, index) => {
        if (msg.message_id === selectedMessId) {
          rxio.socket.emit('reaction_message', {
            group_id: msg.group_id,
            message_id: msg.message_id,
            type: REACTIONS.findIndex(r => r.props.id == emoji.id)
          }, (response) => {
            msg.reactions = response.reactions
            this.setState({ messages });
          })
        }
      })
    })
  }

  handleClickEmoji = (msgId) => {
    this.setState({
      currentMessageIdClicked: msgId
    })
  }

  hasActiveEmoji = (msg) => {
    let result = false;
    msg.reactions.forEach((r) => {
      if (r?.cnt > 0) {
        result = true
      }
    })
    // if(msg.message == "44452Tg") console.log(msg.message, result);
    return result;
  }

  countAllReactions = (msg) => msg && msg.reactions && msg.reactions.reduce((total, r) => total + r.cnt, 0)

  countActiveReaction = (msg) => msg && msg.reactions && msg.reactions.reduce((count, r) => r.cnt && count + 1, 0)

  async checkAndUpdatePolls(mess) {
    // let attachments = JSON.parse(rxaget(mess, 'attachments', ''))
    let attachments = getAttachments(mess)
    let poll_type = attachments.poll_type
    let group_id = mess.group_id
    let poll_id = attachments.poll_id
    let user_answers_uin = attachments.user_answers_uin
    let sender_uin = mess.sender_uin
    let mess_selected = rxaget(this.state, 'mess_selected', {})
    let resendPollMessId = rxaget(this.resendPollAction, 'mess.message_id', '')
    if (mess.status === 4) {
      this.deletePollInfo(attachments, group_id)
      if (resendPollMessId !== mess.message_id) {
        this.resendPollAction = { flag: false, mess: {} }
        this.setState({ pinedMess: this.pullFromObjMessByPollId(this.state.pinedMess, attachments.poll_id) })
      }
    } else {
      switch (poll_type) {
        case 1:
          this.addPollInfo(attachments, group_id)
          break;
        case 2:
          //finish poll
          this.updateFinishStatus(poll_id, group_id)
          break;
        case 3:
          //create poll answers
          this.updateUsersAnswer(user_answers_uin, poll_id, group_id, sender_uin)
          // this.updateUsersAnswerByApi(poll_id, group_id)
          break;
        case 4:
          //resend poll
          let mess = await this.getPollCurrentMsg(attachments)
          this.updateObjMessDeleted(mess)
          break;

        default:
          break;
      }
    }
  }
  async deletePollInfo(pollInfo, group_id) {
    let polls = await chatDB.polls.get({ group_id: group_id })
    let pollsArr = polls.data
    for (let i = 0; i < pollsArr.length; i++) {
      if (pollInfo.poll_id === pollsArr[i].poll_id) {
        pollsArr.splice(i, 1)
      }
    }
    let params = {
      group_id: group_id,
      data: pollsArr,
    }

    await chatDB.polls.put(params, group_id.toString()).then(() => {
      this.props.changePollsFunc()
    })
  }
  async addPollInfo(pollInfo, group_id) {
    let foundPollInfo = false
    let polls = await chatDB.polls.get({ group_id: group_id })
    let pollsArr = []
    if (polls) {
      pollsArr = polls.data
    }

    for (let i = 0; i < pollsArr.length; i++) {
      if (pollInfo.poll_id === pollsArr[i].poll_id) {
        pollsArr[i].message_id = pollInfo.message_id
        foundPollInfo = true
      }
    }

    if (!foundPollInfo) {
      // pollsArr.push(pollInfo)
      let pollInfoTmp = await this.getPollById(pollInfo.poll_id)
      pollsArr.push(pollInfoTmp)
    }

    let params = {
      group_id: group_id,
      data: pollsArr,
    }

    await chatDB.polls.put(params, group_id.toString()).then(() => {
      this.props.changePollsFunc()
    })
  }

  async getPollById(poll_id) {
    let headers = { 'Accept': 'application/json', 'Content-Type': 'application/json; charset=utf-8', 'TC-Token': this.token }
    let pollInfo = await fetch(global.rxu.get(global.rxu.config, 'api_get_poll') + poll_id, {
      method: 'GET',
      body: null,
      headers: headers
    })

    return pollInfo.json()
  }

  async updateFinishStatus(poll_id, group_id) {
    let pollInfo = await this.getPollItem(poll_id, group_id)
    if (pollInfo) {
      pollInfo.status = 2
    }
    let polls = await chatDB.polls.get({ group_id: group_id })
    let pollsArr = polls.data
    for (let i = 0; i < pollsArr.length; i++) {
      if (pollInfo && pollInfo.poll_id === pollsArr[i].poll_id) {
        pollsArr[i] = { ...pollInfo }
      }
    }
    let params = {
      group_id: group_id,
      data: pollsArr,
    }

    await chatDB.polls.put(params, group_id.toString()).then(() => {
      this.props.changePollsFunc()
    })

  }

  async updateUsersAnswer(user_answers_uin, poll_id, group_id, sender_uin) {
    let foundSenderUser = false
    let total_user_voted = 0
    let pollInfo = await this.getPollItem(poll_id, group_id)
    if (pollInfo && user_answers_uin && user_answers_uin.length > 0) {
      // pollInfo = await this.getPollItem(poll_id, group_id)
      let answers = [...pollInfo?.answers]
      let userid = Number(sender_uin)

      let userParams = {
        Id: userid,
        full_name: '',
        is_hide_searched: 0,
        login: '',
        my_cloud_id: 0

      }
      for (let i = 0; i < answers.length; i++) {
        // let users = [...answers[i].users]
        if (user_answers_uin.indexOf(answers[i].id) !== -1) {
          let user = answers[i].users.find(o => o.Id === userid);
          if (!user) {
            answers[i].users.push(userParams)
            // answers[i].total_user_voted ++
          } else {
            foundSenderUser = true
          }
        } else {
          let users_new = answers[i].users.filter((o) => { return o.Id !== userid });
          let user = answers[i].users.find(o => o.Id === userid);
          if (user) {
            answers[i].users = users_new
            // answers[i].total_user_voted --
          }
        }
      }

      pollInfo.answers = answers
    } else {
      pollInfo = await this.getPollById(poll_id)
    }
    let polls = await chatDB.polls.get({ group_id: group_id })
    let pollsArr = polls.data
    total_user_voted = pollInfo.total_user_voted
    if (!foundSenderUser) {
      total_user_voted++
    }
    pollInfo.total_user_voted = total_user_voted

    for (let i = 0; i < pollsArr.length; i++) {
      if (pollInfo.poll_id === pollsArr[i].poll_id) {
        pollsArr[i] = pollInfo
      }
    }

    let params = {
      group_id: group_id,
      data: pollsArr,
    }

    await chatDB.polls.put(params, group_id.toString()).then(() => {
      this.props.changePollsFunc()
    })

  }

  async updateUsersAnswerByApi(poll_id, group_id) {
    let headers = { 'Accept': 'application/json', 'Content-Type': 'application/json; charset=utf-8', 'TC-Token': this.token }
    fetch(global.rxu.get(global.rxu.config, 'api_get_poll') + poll_id, {
      method: 'GET',
      body: null,
      headers: headers
    })
      .then((res) => { return res.json() })
      .then(async (json) => {
        let pollInfo = { ...json }
        let polls = await chatDB.polls.get({ group_id: group_id })
        let pollsArr = polls.data
        for (let i = 0; i < pollsArr.length; i++) {
          if (pollInfo.poll_id === pollsArr[i].poll_id) {
            pollsArr[i] = pollInfo
          }
        }
        let params = {
          group_id: group_id,
          data: pollsArr,
        }

        await chatDB.polls.put(params, group_id.toString()).then(() => {
          this.props.changePollsFunc()
        })
      }).catch(er => console.log(er))
  }

  async getPollItem(poll_id, group_id) {
    let polls = await chatDB.polls.get({ group_id: group_id })
    let pollsArr = polls.data

    let pollItem = pollsArr.find(o => o.poll_id === poll_id)
    return pollItem
  }

  updateObjMessDeleted(omess) {
    const messages = this.state.messages
    const created_at = convertSecondUnix(Number(rxaget(omess, 'created_at', 0)))
    let datetime = timesUnixToDate(created_at, Number(rxaget(omess, 'created_at', 0)))

    if (messages[datetime.toString()] && messages[datetime.toString()].data && messages[datetime.toString()].data.constructor === Array) {
      messages[datetime.toString()].data.forEach(mess => {
        if (mess.message_id === omess.message_id) {
          mess.status = 4
          chatDB.mess.put(mess, omess.message_id)
        }
      })
      this.setState({ messages: messages })
    }
  }

  sendDataToFooter(mess, option) {
    let elem = document.getElementById('chat-value')
    if (elem) {
      elem.dispatchEvent(new CustomEvent('chooseOption', {
        detail: {
          mess_selected: mess,
          type_option: option
        }
      }))
    }
  }

  deletePollMessage(pollmess) {
    let undoStatus = false
    this.deleteMessage(undoStatus, pollmess)
  }

  pinPoll(omess) {
    if (omess && omess.message_id) {
      this.setState({ mess_selected: omess, flagPollListOption: false }, () => {
        this.pinMessage(true)
      })
    }
  }

  choosePoll(pollInfo) {
    this.setState({ pollInfo: pollInfo, flagPollListOption: true })
  }
  createPollAnswers(pollInfo) {
    this.sendPollDataToFooter(pollInfo, 'createPollAnswers')
    this.setState({ pollInfo: pollInfo })
  }

  async getPollCurrentMsg(pollInfo) {
    let omess
    if (pollInfo.currentMsg && pollInfo.currentMsg.message_id) {
      omess = pollInfo.currentMsg
    } else {
      let messInDB = await chatDB.mess.get({ message_id: pollInfo.message_id.toString() })
      if (messInDB && messInDB.message_id) {
        omess = messInDB
      } else {
        let messages = this.state.messages
        let foundMess = false
        for (const key in messages) {
          if (!foundMess) {
            let subMessages = messages[key]
            let messTmp = subMessages.data.find(ele => { return ele.message_id === pollInfo.message_id })
            if (messTmp && messTmp.message_id) {
              omess = messTmp
              foundMess = true
            }
          }
        }


      }
    }
    return omess
  }

  async morepollChoose(value, pollInfo) {
    let omess = await this.getPollCurrentMsg(pollInfo)
    switch (value) {
      case 'pin':

        this.pinPoll(omess)
        // code block
        break;

      case 'unpin':
        this.unPinPoll(pollInfo)
        // code block
        break;
      case 'send':
        // await this.sendPollDataToFooter(pollInfo, 'sendPollMess')
        let pinMessStatus = 0
        if (omess && omess.message_id) {
          pinMessStatus = this.checkPinMessById(omess.message_id)
          if (pinMessStatus === 2) {
            this.unPinPoll(pollInfo, 'resend-poll')
          }
          this.resendPollAction = { flag: true, mess: omess }
          this.updateObjMessDeleted(omess)
        }
        pollInfo.pinMessStatus = pinMessStatus
        await this.sendPollDataToFooter(pollInfo, 'sendPollMess')
        this.setState({ flagPollListOption: false })
        // code block
        break;
      case 'delete':
        this.deleteVote(pollInfo)
        let firstInitPollMess = this.getFirstInitPollMess(this.state.pinedMess, pollInfo.poll_id)
        if (firstInitPollMess && firstInitPollMess.message_id) {
          this.unPinPollMessFirstInit(firstInitPollMess)
        }
        if (omess && omess.message_id) {
          this.setState({ mess_selected: omess, flagPollListOption: false, pinedMess: this.pullFromObjMessByPollId(this.state.pinedMess, pollInfo.poll_id) }, () => {

            this.deletePollMessage(omess)
          })
        } else {
          this.setState({ flagPollListOption: false, pinedMess: this.pullFromObjMessByPollId(this.state.pinedMess, pollInfo.poll_id) })
        }
        // code block
        break;
      case 'finish-poll':
        this.sendPollDataToFooter(pollInfo, 'finishPoll')
        this.endVote(pollInfo)
        break;
      default:
      // code block
    }
    // console.log(value,pollInfo,"???")
  }

  sendPollDataToFooter(pollInfo, typeAction) {
    let elem = document.getElementById('chat-value')
    elem.dispatchEvent(new CustomEvent('chooseOption', {
      detail: {
        pollInfo: pollInfo,
        type: typeAction
      }
    }))
  }

  deleteVote(pollInfo) {

    let group_id = this.state.group_id
    let headers = { 'Accept': 'application/json', 'Content-Type': 'application/json; charset=utf-8', 'TC-Token': this.token }
    let params = {
      "group_id": group_id.toString(),
      "poll_id": pollInfo.poll_id,
    }
    fetch(global.rxu.get(global.rxu.config, 'api_poll_delete_vote'), {
      method: 'DELETE',
      body: JSON.stringify(params),
      headers: headers
    })
      .then((res) => { return res.json() })
      .then((json) => {
        this.deletePollInfo(pollInfo, group_id)
      }).catch(er => console.log(er))
  }

  async endVote(pollInfo) {
    let group_id = this.state.group_id
    let pollTmp = await this.getPollItem(pollInfo.poll_id, group_id)
    let headers = { 'Accept': 'application/json', 'Content-Type': 'application/json; charset=utf-8', 'TC-Token': this.token }
    let params = {
      "group_id": group_id.toString(),
      "poll_id": pollInfo.poll_id,
    }
    fetch(global.rxu.get(global.rxu.config, 'api_poll_end_vote'), {
      method: 'POST',
      body: JSON.stringify(params),
      headers: headers
    })
      .then((res) => { return res.json() })
      .then((json) => {
        if (json && json.message && json.message === 'success') {
          pollInfo.status = 2
          pollInfo.answers = [...pollTmp.answers]
          this.updateFinishStatus(pollInfo.poll_id, group_id)
          this.setState({ pollInfo: pollInfo })
        }
      }).catch(er => console.log(er))
  }

  checkpollOption(value) {
    let showOption = false
    let mess_selected = this.state.mess_selected
    if (mess_selected.type !== 17) {
      if (value === 'resend-poll') {
        showOption = false
      } else if (['delete_all', 'delete_one'].indexOf(value) !== -1) {
        if (mess_selected.sender_uin === this.userid.toString()) {
          showOption = true
        }
      } else {
        showOption = true
      }
    } else {
      if (value === 'resend-poll') {
        showOption = true
      } else if (['pin', 'unpin', 'delete_all', 'delete_one'].indexOf(value) !== -1) {
        if (this.state.group.owner_uin.toString() === this.userid.toString()) {
          showOption = true
        }
      }

    }
    return showOption
  }

  render() {
    // console.log('Message Render')
    return (
      <Fragment>
        {this.renderComponent()}
      </Fragment>)
  }
}
const mapStateToProps = (state, ownProps) => ({
  themeValue: state.themeValue,
  langValue: state.langValue,
  rxgroup: state.rxgroup,
  netaauth: state.netaauth,
  netaMess: state.netaMess,
  netaPinMess: state.netaPinMess,
  tabmore: state.tabmore,
  group_id: state.group_id,
  // netaGroups: state.netaGroups,
  netaLink: state.netaLink,
  loadmess: state.loadmess,
  rxnav: state.rxnav
})
const mapDispatchToProps = {
  netaBlobsUpdate,
  netaMessUpdate,
  netaMessPin,
  chooseGroupAction,
  netaUserUpdate,
  netaGroupsUpdate,
  netaGroupsUpdateLastMess,
  changeStatusTabmore,
  netaLinkAdd,
  netaGroupsRemove,
  changeUserStatus,
  netaMediaOneAdd,
  userClickUpdate,
  clickGroupCall,
  netaGroupCallRemove,
  netaMediaOneDel,
  rxnavToggle,
  changeGroupFunc,
  changePollsFunc
}
const MessagesWrapped = connect(
  mapStateToProps,
  mapDispatchToProps
)(MessageComponent_)
export default MessagesWrapped